import React, { useState } from "react";
import {
  AiOutlineClose,
  AiOutlineDelete,
  AiOutlineDownload,
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineLogout,
  AiOutlinePlus,
  AiOutlineRollback,
  AiOutlineSave,
  AiOutlineSetting,
  AiOutlineUpload,
  AiOutlineArrowRight,
} from "react-icons/ai";
import {
  FaBox,
  FaHistory,
  FaSearch,
  FaTimes,
  FaTrash,
  FaQrcode,
} from "react-icons/fa";
import { GoPrimitiveDot } from "react-icons/go";
import {
  MdEdit,
  MdSettingsBackupRestore,
  MdOutlineArrowBackIosNew,
} from "react-icons/md";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { GiExpand } from "react-icons/gi";
import { HiDuplicate } from "react-icons/hi";
import { ImCancelCircle } from "react-icons/im";

import RollbackedSvg from "../../../assets/images/rollbacked.svg";

export const XIcon = (props) => (
  <AiOutlineClose
    color="#000000"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconCancel = (props) => {
  return (
    <ImCancelCircle
      style={{
        width: 15,
        height: 15,
      }}
      color="#E61D01"
      {...props}
    />
  );
};

export const IconHistory = (props) => (
  <FaHistory color="#FFFFFF" className="text-sm cursor-pointer" {...props} />
);
export const IconDot = (props) => (
  <GoPrimitiveDot className="text-sm cursor-pointer" {...props} />
);
export const IconEdit = (props) => (
  <MdEdit color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);
export const IconDownload = (props) => (
  <AiOutlineDownload
    color="#C4C4C4"
    className="text-sm cursor-pointer"
    {...props}
  />
);
export const IconSearch = (props) => (
  <FaSearch color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);
export const IconTimes = (props) => (
  <FaTimes color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);
export const IconTrash = (props) => (
  <FaTrash color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);
export const IconBox = (props) => (
  <FaBox color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);

export const IconChevron = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    {...props}
  >
    <path
      d="M3.48099 4.7721L0.172037 1.10814C-0.218469 0.677051 0.0989034 2.4576e-07 0.691562 2.4576e-07L7.30947 2.4576e-07C7.4421 -0.000109918 7.57196 0.0368186 7.68349 0.106364C7.79502 0.175909 7.88349 0.275122 7.93831 0.392123C7.99313 0.509124 8.01198 0.638953 7.99259 0.766061C7.9732 0.89317 7.9164 1.01217 7.82899 1.10881L4.52004 4.77143C4.45528 4.84322 4.37542 4.90076 4.28581 4.94018C4.19621 4.9796 4.09893 5 4.00051 5C3.9021 5 3.80482 4.9796 3.71522 4.94018C3.62561 4.90076 3.54575 4.84322 3.48099 4.77143V4.7721Z"
      fill="white"
    />
  </svg>
);

export const IconChevronUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    viewBox="0 0 7 6"
    fill="#BFBFBF"
    {...props}
  >
    <path d="M0 4.2H6L3 0L0 4.2Z" />
  </svg>
);
export const IconChevronDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    viewBox="0 0 7 6"
    fill="#BFBFBF"
    {...props}
  >
    <path d="M6 -4.86374e-05L-3.67176e-07 -4.81129e-05L3 4.19995L6 -4.86374e-05Z" />
  </svg>
);

export const IconChevronDownSolid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    {...props}
  >
    <path
      d="M11.3333 6.33334L5.99998 1.00001L0.666646 6.33334"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconChevronUpSolid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    {...props}
  >
    <path
      d="M0.666656 1L5.99999 6.33333L11.3333 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconRollBack = (props) => (
  <AiOutlineRollback
    color="#fff"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconRollBacked = (props) => (
  <div color="#fff" className="text-sm cursor-not-allowed" {...props}>
    <img src={RollbackedSvg} />
  </div>
);

export const IconExclamation = (props) => (
  <ExclamationCircleOutlined
    color="#C4C4C4"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconBack = (props) => (
  <MdOutlineArrowBackIosNew
    color="#000"
    className="text-sm cursor-pointer"
    {...props}
  />
);
export const IconRestore = (props) => (
  <MdSettingsBackupRestore
    color="#83838366"
    className="text-sm cursor-pointer"
    {...props}
  />
);
export const IconSetting = (props) => (
  <AiOutlineSetting
    color="#C4C4C4"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconEyeInvisible = (props) => (
  <AiOutlineEyeInvisible
    color="#C4C4C4"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconEye = (props) => (
  <AiOutlineEye color="#fff" className="text-sm cursor-pointer" {...props} />
);

export const IconQrcode = (props) => (
  <FaQrcode
    color="#000"
    style={{ marginLeft: "5px", marginTop: "-5px" }}
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconExpand = (props) => (
  <GiExpand color="#BFBFBF" className="text-xl cursor-pointer" {...props} />
);

// custom
export const IconSave = (props) => (
  <AiOutlineSave fill="#C4C4C4" className="cursor-pointer text-sm" {...props} />
);

export const IconCopy = (props) => (
  <SvgCopy color="#fff" className="text-sm cursor-pointer" {...props} />
);

export const IconAccounting = (props) => (
  <SvgAccounting color="#fff" className="text-sm cursor-pointer" {...props} />
);

export const IconEraser = (props) => (
  <SvgEraser color="#fff" className="text-sm cursor-pointer" {...props} />
);
export const IconSadFace = (props) => (
  <SvgSadFace className="text-sm cursor-pointer" {...props} />
);

export const IconDocNumber = (props) => (
  <SvgDocNumber className="text-sm cursor-pointer" {...props} />
);
export const IconWarehouse = (props) => (
  <SvgWarehouse className="text-sm cursor-pointer" {...props} />
);

export const IconWarehouse2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="#03B0F7"
    {...props}
  >
    <path d="M15.5 12.25V4.2625C15.5 3.6475 15.125 3.1 14.555 2.8675L8.555 0.467501C8.195 0.325001 7.7975 0.325001 7.4375 0.467501L1.4375 2.8675C0.875 3.1 0.5 3.655 0.5 4.2625V12.25C0.5 13.075 1.175 13.75 2 13.75H4.25V7H11.75V13.75H14C14.825 13.75 15.5 13.075 15.5 12.25Z" />
  </svg>
);

export const IconWarehouse3 = (props) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.33341 11.5833H3.50008V6.91665H10.5001V11.5833H11.6667V5.37082L7.00008 3.50415L2.33341 5.37082V11.5833ZM1.16675 12.75V4.58332L7.00008 2.24998L12.8334 4.58332V12.75H9.33342V8.08332H4.66675V12.75H1.16675ZM5.25008 12.75V11.5833H6.41675V12.75H5.25008ZM6.41675 11V9.83332H7.58342V11H6.41675ZM7.58342 12.75V11.5833H8.75008V12.75H7.58342Z"
      fill="black"
    />
  </svg>
);

const SvgDocNumber = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      {...props}
    >
      <path d="M5.598 4.995L5.374 6H4.404L4.626 4.995H5.598ZM2 0H8C8.53043 0 9.03914 0.210714 9.41421 0.585786C9.78929 0.960859 10 1.46957 10 2V11.497C10 11.6296 9.94732 11.7568 9.85355 11.8506C9.75979 11.9443 9.63261 11.997 9.5 11.997H1V12C1 12.2652 1.10536 12.5196 1.29289 12.7071C1.48043 12.8946 1.73478 13 2 13H9.5C9.63261 13 9.75979 13.0527 9.85355 13.1464C9.94732 13.2402 10 13.3674 10 13.5C10 13.6326 9.94732 13.7598 9.85355 13.8536C9.75979 13.9473 9.63261 14 9.5 14H2C1.46957 14 0.960859 13.7893 0.585786 13.4142C0.210714 13.0391 0 12.5304 0 12V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0ZM4.988 3.36C5.01664 3.23044 4.99265 3.09481 4.92129 2.98295C4.84993 2.87108 4.73706 2.79214 4.6075 2.7635C4.47794 2.73486 4.34231 2.75885 4.23045 2.83021C4.11858 2.90157 4.03964 3.01444 4.011 3.144L3.823 3.995H3C2.86739 3.995 2.74021 4.04768 2.64645 4.14145C2.55268 4.23521 2.5 4.36239 2.5 4.495C2.5 4.62761 2.55268 4.75479 2.64645 4.84855C2.74021 4.94232 2.86739 4.995 3 4.995H3.601L3.38 6H2.5C2.36739 6 2.24021 6.05268 2.14645 6.14645C2.05268 6.24021 2 6.36739 2 6.5C2 6.63261 2.05268 6.75979 2.14645 6.85355C2.24021 6.94732 2.36739 7 2.5 7H3.158L3.016 7.638C2.98736 7.76756 3.01135 7.90319 3.08271 8.01505C3.15407 8.12692 3.26694 8.20586 3.3965 8.2345C3.52606 8.26314 3.66169 8.23915 3.77355 8.16779C3.88542 8.09643 3.96436 7.98356 3.993 7.854L4.182 7H5.151L5.008 7.637C4.99369 7.70109 4.99213 7.76736 5.00343 7.83205C5.01473 7.89673 5.03866 7.95856 5.07386 8.01399C5.10905 8.06943 5.15482 8.11739 5.20855 8.15514C5.26228 8.19289 5.32292 8.21969 5.387 8.234C5.45109 8.24831 5.51736 8.24987 5.58205 8.23857C5.64673 8.22727 5.70856 8.20334 5.76399 8.16814C5.81943 8.13295 5.86739 8.08718 5.90514 8.03345C5.94289 7.97972 5.96969 7.91908 5.984 7.855L6.175 7H7C7.13261 7 7.25979 6.94732 7.35355 6.85355C7.44732 6.75979 7.5 6.63261 7.5 6.5C7.5 6.36739 7.44732 6.24021 7.35355 6.14645C7.25979 6.05268 7.13261 6 7 6H6.398L6.623 4.995H7.5C7.63261 4.995 7.75979 4.94232 7.85355 4.84855C7.94732 4.75479 8 4.62761 8 4.495C8 4.36239 7.94732 4.23521 7.85355 4.14145C7.75979 4.04768 7.63261 3.995 7.5 3.995H6.846L6.987 3.362C7.00131 3.29791 7.00287 3.23164 6.99157 3.16695C6.98027 3.10227 6.95634 3.04044 6.92114 2.98501C6.88595 2.92957 6.84018 2.88161 6.78645 2.84386C6.73272 2.80611 6.67208 2.77931 6.608 2.765C6.54391 2.75069 6.47764 2.74913 6.41295 2.76043C6.34827 2.77173 6.28644 2.79566 6.23101 2.83086C6.11905 2.90193 6.03991 3.01457 6.011 3.144L5.821 3.995H4.847L4.987 3.361L4.988 3.36Z" />
    </svg>
  );
};

const SvgWarehouse = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      {...props}
    >
      <path d="M15.5 12.25V4.26247C15.5 3.64747 15.125 3.09997 14.555 2.86747L8.555 0.467471C8.195 0.324971 7.7975 0.324971 7.4375 0.467471L1.4375 2.86747C0.875 3.09997 0.5 3.65497 0.5 4.26247V12.25C0.5 13.075 1.175 13.75 2 13.75H4.25V6.99997H11.75V13.75H14C14.825 13.75 15.5 13.075 15.5 12.25ZM7.25 12.25H5.75V13.75H7.25V12.25ZM8.75 9.99997H7.25V11.5H8.75V9.99997ZM10.25 12.25H8.75V13.75H10.25V12.25Z" />
    </svg>
  );
};
const SvgSadFace = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.50008 1.62496C3.80769 1.62496 1.62508 3.80757 1.62508 6.49996C1.62508 9.19235 3.80769 11.375 6.50008 11.375C9.19247 11.375 11.3751 9.19235 11.3751 6.49996C11.3751 3.80757 9.19247 1.62496 6.50008 1.62496ZM0.541748 6.49996C0.541748 3.20926 3.20938 0.541626 6.50008 0.541626C9.79078 0.541626 12.4584 3.20926 12.4584 6.49996C12.4584 9.79066 9.79078 12.4583 6.50008 12.4583C3.20938 12.4583 0.541748 9.79066 0.541748 6.49996Z"
        fill="#03B0F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66678 4.30615C8.96593 4.30615 9.20844 4.54866 9.20844 4.84782V4.90199C9.20844 5.20114 8.96593 5.44365 8.66678 5.44365C8.36762 5.44365 8.12511 5.20114 8.12511 4.90199V4.84782C8.12511 4.54866 8.36762 4.30615 8.66678 4.30615Z"
        fill="#03B0F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.60441 4.30615C4.90357 4.30615 5.14608 4.54866 5.14608 4.84782V4.90199C5.14608 5.20114 4.90357 5.44365 4.60441 5.44365C4.30526 5.44365 4.06274 5.20114 4.06274 4.90199V4.84782C4.06274 4.54866 4.30526 4.30615 4.60441 4.30615Z"
        fill="#03B0F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.50008 7.58333C6.0691 7.58333 5.65578 7.75454 5.35103 8.05928C5.17802 8.2323 5.04805 8.4403 4.96802 8.66667H8.03215C7.95211 8.4403 7.82214 8.2323 7.64913 8.05928C7.34438 7.75454 6.93106 7.58333 6.50008 7.58333ZM4.585 7.29325C5.09291 6.78534 5.78179 6.5 6.50008 6.5C7.21838 6.5 7.90725 6.78534 8.41516 7.29325C8.92307 7.80116 9.20841 8.49004 9.20841 9.20833C9.20841 9.35199 9.15135 9.48977 9.04976 9.59135C8.94818 9.69293 8.81041 9.75 8.66675 9.75H4.33341C4.03426 9.75 3.79175 9.50749 3.79175 9.20833C3.79175 8.49004 4.07709 7.80116 4.585 7.29325Z"
        fill="#03B0F7"
      />
    </svg>
  );
};

export const IconMessage = (props) => (
  <SvgMessage color="#fff" className="text-sm cursor-pointer" {...props} />
);

// CUSTOM SVGS

const SvgMessage = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      {...props}
    >
      <path
        d="M13.1667 0.416672H1.83341C1.05212 0.416672 0.416748 1.05205 0.416748 1.83334V14.5833L3.25008 11.75H13.1667C13.948 11.75 14.5834 11.1146 14.5834 10.3333V1.83334C14.5834 1.05205 13.948 0.416672 13.1667 0.416672ZM5.37508 7.50001C5.189 7.49996 5.00474 7.46326 4.83284 7.39201C4.66093 7.32075 4.50475 7.21633 4.3732 7.08472C4.24165 6.9531 4.13731 6.79687 4.06614 6.62493C3.99497 6.45299 3.95837 6.26872 3.95842 6.08263C3.95846 5.89654 3.99516 5.71229 4.06641 5.54039C4.13767 5.36848 4.24209 5.2123 4.3737 5.08075C4.50532 4.9492 4.66155 4.84486 4.83349 4.77369C5.00543 4.70252 5.1897 4.66592 5.37579 4.66596C5.75161 4.66606 6.11199 4.81544 6.37767 5.08125C6.64335 5.34706 6.79255 5.70752 6.79246 6.08334C6.79236 6.45916 6.64298 6.81954 6.37717 7.08522C6.11136 7.3509 5.7509 7.5001 5.37508 7.50001ZM9.62508 7.50001C9.439 7.49996 9.25474 7.46326 9.08284 7.39201C8.91094 7.32075 8.75475 7.21633 8.6232 7.08472C8.49165 6.9531 8.38731 6.79687 8.31614 6.62493C8.24497 6.45299 8.20837 6.26872 8.20842 6.08263C8.20846 5.89654 8.24516 5.71229 8.31642 5.54039C8.38767 5.36848 8.49209 5.2123 8.6237 5.08075C8.75532 4.9492 8.91155 4.84486 9.08349 4.77369C9.25543 4.70252 9.4397 4.66592 9.62579 4.66596C10.0016 4.66606 10.362 4.81544 10.6277 5.08125C10.8933 5.34706 11.0426 5.70752 11.0425 6.08334C11.0424 6.45916 10.893 6.81954 10.6272 7.08522C10.3614 7.3509 10.0009 7.5001 9.62508 7.50001Z"
      // fill="#EF3824"
      />
    </svg>
  );
};

const SvgCopy = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M3.95 5.64998C3.95 5.19911 4.1291 4.76671 4.44792 4.4479C4.76673 4.12909 5.19913 3.94998 5.65 3.94998H10.75C11.2009 3.94998 11.6333 4.12909 11.9521 4.4479C12.2709 4.76671 12.45 5.19911 12.45 5.64998V10.75C12.45 11.2009 12.2709 11.6333 11.9521 11.9521C11.6333 12.2709 11.2009 12.45 10.75 12.45H5.65C5.19913 12.45 4.76673 12.2709 4.44792 11.9521C4.1291 11.6333 3.95 11.2009 3.95 10.75V5.64998Z"
        fill="#F7951E"
      />
      <path
        d="M2.25 0.549988C1.79913 0.549988 1.36673 0.729094 1.04792 1.04791C0.72911 1.36672 0.550003 1.79912 0.550003 2.24999V7.34999C0.550003 7.80086 0.72911 8.23326 1.04792 8.55207C1.36673 8.87088 1.79913 9.04999 2.25 9.04999V2.24999H9.05C9.05 1.79912 8.8709 1.36672 8.55208 1.04791C8.23327 0.729094 7.80087 0.549988 7.35 0.549988H2.25Z"
        fill="#F7951E"
      />
    </svg>
  );
};

const SvgEraser = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.750001 5.45C0.56253 5.63753 0.457214 5.89183 0.457214 6.157C0.457214 6.42216 0.56253 6.67647 0.750001 6.864L2.679 8.793H1.043C0.910393 8.793 0.783216 8.84568 0.689447 8.93945C0.595679 9.03321 0.543001 9.16039 0.543001 9.293C0.543001 9.42561 0.595679 9.55278 0.689447 9.64655C0.783216 9.74032 0.910393 9.793 1.043 9.793H9.043C9.17561 9.793 9.30279 9.74032 9.39655 9.64655C9.49032 9.55278 9.543 9.42561 9.543 9.293C9.543 9.16039 9.49032 9.03321 9.39655 8.93945C9.30279 8.84568 9.17561 8.793 9.043 8.793H4.478L9.2355 4.0355C9.42297 3.84797 9.52829 3.59366 9.52829 3.3285C9.52829 3.06333 9.42297 2.80903 9.2355 2.6215L7.1135 0.499999C7.02064 0.407098 6.91038 0.333402 6.78903 0.283122C6.66768 0.232842 6.53761 0.206963 6.40625 0.206963C6.2749 0.206963 6.14483 0.232842 6.02347 0.283122C5.90212 0.333402 5.79186 0.407098 5.699 0.499999L0.750001 5.45ZM2.913 4.701L1.457 6.157L3.5785 8.278L5.034 6.8225L2.913 4.701ZM3.62 3.994L5.7415 6.115L8.528 3.3285L6.407 1.207L3.62 3.994Z"
        fill="white"
      />
    </svg>
  );
};

const SvgAccounting = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
    >
      <path
        d="M1.41675 1.41666H2.83341V15.5833H1.41675V1.41666Z"
        fill="#383838"
      />
      <path
        d="M15.5834 2.83334V4.25001H1.41675V2.83334H15.5834Z"
        fill="#383838"
      />
      <path
        d="M14.1667 1.41666H15.5834V15.5833H14.1667V1.41666Z"
        fill="#383838"
      />
      <path
        d="M5.66667 4.95833C6.44907 4.95833 7.08333 4.32407 7.08333 3.54167C7.08333 2.75926 6.44907 2.125 5.66667 2.125C4.88426 2.125 4.25 2.75926 4.25 3.54167C4.25 4.32407 4.88426 4.95833 5.66667 4.95833Z"
        fill="#383838"
      />
      <path
        d="M15.5834 7.08334V8.50001H1.41675V7.08334H15.5834Z"
        fill="#383838"
      />
      <path
        d="M7.08341 9.20833C7.86582 9.20833 8.50008 8.57407 8.50008 7.79167C8.50008 7.00926 7.86582 6.375 7.08341 6.375C6.30101 6.375 5.66675 7.00926 5.66675 7.79167C5.66675 8.57407 6.30101 9.20833 7.08341 9.20833Z"
        fill="#383838"
      />
      <path
        d="M11.3334 9.20833C12.1158 9.20833 12.7501 8.57407 12.7501 7.79167C12.7501 7.00926 12.1158 6.375 11.3334 6.375C10.551 6.375 9.91675 7.00926 9.91675 7.79167C9.91675 8.57407 10.551 9.20833 11.3334 9.20833Z"
        fill="#383838"
      />
      <path
        d="M15.5833 11.3333V12.75H1.41667V11.3333H15.5833ZM17 14.875V16.2916H0V14.875H17Z"
        fill="#383838"
      />
      <path
        d="M5.66667 13.4583C6.44907 13.4583 7.08333 12.8241 7.08333 12.0417C7.08333 11.2593 6.44907 10.625 5.66667 10.625C4.88426 10.625 4.25 11.2593 4.25 12.0417C4.25 12.8241 4.88426 13.4583 5.66667 13.4583Z"
        fill="#383838"
      />
    </svg>
  );
};

const SvgIcon = (props) => {
  return (
    <svg
      id="Capa_1"
      enable-background="new 0 0 512.007 512.007"
      height="12"
      viewBox="0 0 512.007 512.007"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="m142 143.003h139v-143c-49.379 0-107.674 0-154 0v128c0 8.271 6.729 15 15 15z" />
        <path d="m345 128.003v-128c-9.97 0-21.461 0-34 0v143h19c8.271 0 15-6.729 15-15z" />
        <path d="m127 512.003h218v-161h-218z" />
        <path d="m511.927 126.537c-.279-2.828-1.38-5.667-3.315-8.027-.747-.913 6.893 6.786-114.006-114.113-2.882-2.882-6.794-4.396-10.612-4.394-.789 0-3.925 0-8.995 0v128c0 24.813-20.187 45-45 45-14.028 0-186.064 0-188 0-24.813 0-45-20.187-45-45v-128c-29.589 0-49.82 0-52 0-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h52c0-10.815 0-201.797 0-210 0-24.813 20.187-45 45-45h188c24.813 0 45 20.187 45 45v210h92c24.813 0 45-20.187 45-45 .001-364.186.041-339.316-.072-340.466z" />
        <path d="m330 287.003h-188c-8.271 0-15 6.729-15 15v19h218v-19c0-8.271-6.729-15-15-15z" />
      </g>
    </svg>
  );
};

// SVG USER

export const IconUser = (props) => (
  <SvgUser className="text-sm cursor-pointer" {...props} />
);

const SvgUser = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      {...props}
    >
      <path
        d="M7.5 1.25C5.84894 1.27106 4.27143 1.9363 3.10387 3.10387C1.9363 4.27143 1.27106 5.84894 1.25 7.5C1.25772 8.46182 1.48733 9.40889 1.92094 10.2675C2.35456 11.126 2.98049 11.8729 3.75 12.45V12.5H3.8125C4.87074 13.3109 6.16678 13.7504 7.5 13.7504C8.83322 13.7504 10.1293 13.3109 11.1875 12.5H11.25V12.45C12.0195 11.8729 12.6454 11.126 13.0791 10.2675C13.5127 9.40889 13.7423 8.46182 13.75 7.5C13.7289 5.84894 13.0637 4.27143 11.8961 3.10387C10.7286 1.9363 9.15106 1.27106 7.5 1.25ZM5.04375 11.8313C5.13499 11.4134 5.36634 11.0393 5.69943 10.771C6.03251 10.5027 6.44731 10.3564 6.875 10.3562H8.125C8.55269 10.3564 8.96749 10.5027 9.30057 10.771C9.63366 11.0393 9.86501 11.4134 9.95625 11.8313C9.21179 12.2693 8.36375 12.5002 7.5 12.5002C6.63625 12.5002 5.78821 12.2693 5.04375 11.8313ZM11.0063 11.025C10.7685 10.4568 10.3682 9.9716 9.85558 9.63022C9.34295 9.28885 8.74089 9.10656 8.125 9.10625H6.875C6.25911 9.10656 5.65704 9.28885 5.14442 9.63022C4.6318 9.9716 4.23148 10.4568 3.99375 11.025C3.52541 10.5644 3.15244 10.016 2.89613 9.41113C2.63983 8.80629 2.50522 8.15688 2.5 7.5C2.51621 6.17895 3.0482 4.91658 3.98239 3.98239C4.91658 3.0482 6.17895 2.51621 7.5 2.5C8.82105 2.51621 10.0834 3.0482 11.0176 3.98239C11.9518 4.91658 12.4838 6.17895 12.5 7.5C12.4948 8.15688 12.3602 8.80629 12.1039 9.41113C11.8476 10.016 11.4746 10.5644 11.0063 11.025Z"
        fill="#03B0F7"
      />
      <path
        d="M7.49999 3.74999C7.16958 3.74229 6.84104 3.8017 6.53425 3.92461C6.22746 4.04752 5.94878 4.23139 5.71509 4.46509C5.48139 4.69878 5.29752 4.97746 5.17461 5.28425C5.0517 5.59104 4.99229 5.91958 4.99999 6.24999C4.99229 6.5804 5.0517 6.90894 5.17461 7.21573C5.29752 7.52252 5.48139 7.8012 5.71509 8.0349C5.94878 8.26859 6.22746 8.45246 6.53425 8.57537C6.84104 8.69828 7.16958 8.75769 7.49999 8.74999C7.8304 8.75769 8.15894 8.69828 8.46573 8.57537C8.77252 8.45246 9.0512 8.26859 9.2849 8.0349C9.51859 7.8012 9.70246 7.52252 9.82537 7.21573C9.94828 6.90894 10.0077 6.5804 9.99999 6.24999C10.0077 5.91958 9.94828 5.59104 9.82537 5.28425C9.70246 4.97746 9.51859 4.69878 9.2849 4.46509C9.0512 4.23139 8.77252 4.04752 8.46573 3.92461C8.15894 3.8017 7.8304 3.74229 7.49999 3.74999ZM7.49999 7.49999C7.33371 7.50803 7.16759 7.4812 7.01229 7.42123C6.85699 7.36125 6.71596 7.26946 6.59824 7.15174C6.48052 7.03403 6.38873 6.89299 6.32876 6.73769C6.26878 6.5824 6.24195 6.41627 6.24999 6.24999C6.24195 6.08371 6.26878 5.91759 6.32876 5.76229C6.38873 5.60699 6.48052 5.46596 6.59824 5.34824C6.71596 5.23052 6.85699 5.13873 7.01229 5.07876C7.16759 5.01878 7.33371 4.99195 7.49999 4.99999C7.66627 4.99195 7.8324 5.01878 7.98769 5.07876C8.14299 5.13873 8.28403 5.23052 8.40174 5.34824C8.51946 5.46596 8.61125 5.60699 8.67123 5.76229C8.7312 5.91759 8.75803 6.08371 8.74999 6.24999C8.75803 6.41627 8.7312 6.5824 8.67123 6.73769C8.61125 6.89299 8.51946 7.03403 8.40174 7.15174C8.28403 7.26946 8.14299 7.36125 7.98769 7.42123C7.8324 7.4812 7.66627 7.50803 7.49999 7.49999Z"
        fill="#03B0F7"
      />
    </svg>
  );
};

// SVG Autosys

export const IconAutosys = (props) => (
  <SvgAutosys className="text-sm cursor-pointer" {...props} />
);

const SvgAutosys = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="#E0E0E0"
      {...props}
    >
      <path d="M4.0625 6.5H8.9375V7.3125H4.0625V6.5ZM4.0625 4.0625H8.9375V4.875H4.0625V4.0625Z" />
      <path d="M6.5 12.1875L3.991 10.8497C3.27573 10.4692 2.67758 9.90107 2.26075 9.20632C1.84392 8.51158 1.62414 7.71644 1.625 6.90625V1.625C1.62522 1.40958 1.71089 1.20304 1.86322 1.05071C2.01554 0.898387 2.22208 0.812715 2.4375 0.8125H10.5625C10.7779 0.812715 10.9845 0.898387 11.1368 1.05071C11.2891 1.20304 11.3748 1.40958 11.375 1.625V6.90625C11.3759 7.71644 11.1561 8.51158 10.7393 9.20632C10.3224 9.90107 9.72427 10.4692 9.009 10.8497L6.5 12.1875ZM2.4375 1.625V6.90625C2.43683 7.56917 2.6167 8.21976 2.95781 8.78818C3.29893 9.35661 3.7884 9.82141 4.37369 10.1327L6.5 11.2665L8.62632 10.1331C9.21167 9.82178 9.70118 9.35692 10.0423 8.78842C10.3834 8.21991 10.5633 7.56924 10.5625 6.90625V1.625H2.4375Z" />
    </svg>
  );
};

// SVG logout

export const IconLogout = (props) => (
  <AiOutlineLogout
    color="#E0E0E0"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconDuplicate = (props) => (
  <HiDuplicate color="#03B0F7" className="cursor-pointer text-xl" {...props} />
);

// Custom svg import

export const IconImport = (props) => (
  <SvgImport className="text-xl cursor-pointer mr-2" {...props} />
);

const SvgImport = (props) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 0C2.86333 0 1.89667 0.356667 1.51333 0.856667L3.26333 2.60667C3.5 2.64333 3.74 2.66667 4 2.66667C5.47333 2.66667 6.66667 2.07 6.66667 1.33333C6.66667 0.596667 5.47333 0 4 0ZM1.30667 1.36L0.833333 1.83333L1.66667 2.66667H0V3.33333H1.66667L0.833333 4.16667L1.30667 4.64L2.94667 3L1.30667 1.36ZM6.66667 2C6.66667 2.73667 5.47333 3.33333 4 3.33333C3.78 3.33333 3.56667 3.31667 3.36333 3.29L2.54 4.11333C2.96 4.25 3.46 4.33333 4 4.33333C5.47333 4.33333 6.66667 3.73667 6.66667 3V2ZM6.66667 3.66667C6.66667 4.40333 5.47333 5 4 5C3.24 5 2.55667 4.83333 2.07 4.58333L1.51 5.14333C1.89333 5.64333 2.86333 6 4 6C5.47333 6 6.66667 5.40333 6.66667 4.66667"
        fill="#03B0F7"
      />
    </svg>
  );
};

export const IconNo = (props) => (
  <SvgNo className="text-sm cursor-pointer" {...props} />
);

const SvgNo = (props) => {
  return (
    <svg
      width="21"
      height="13"
      viewBox="0 0 21 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3945 0.316406H8.72549C8.63848 0.316406 8.56729 0.387598 8.56729 0.474609V9.44473H8.41699L2.20488 0.384961C2.17588 0.342774 2.12578 0.316406 2.07568 0.316406H0.322266C0.235254 0.316406 0.164062 0.387598 0.164062 0.474609V12.709C0.164062 12.796 0.235254 12.8672 0.322266 12.8672H1.97549C2.0625 12.8672 2.13369 12.796 2.13369 12.709V3.61494H2.28398L8.56465 12.7986C8.59365 12.8408 8.64375 12.8672 8.69648 12.8672H10.3945C10.4815 12.8672 10.5527 12.796 10.5527 12.709V0.474609C10.5527 0.387598 10.4815 0.316406 10.3945 0.316406ZM20.3613 11.2061H12.3457C12.2297 11.2061 12.1348 11.301 12.1348 11.417V12.6826C12.1348 12.7986 12.2297 12.8936 12.3457 12.8936H20.3613C20.4773 12.8936 20.5723 12.7986 20.5723 12.6826V11.417C20.5723 11.301 20.4773 11.2061 20.3613 11.2061ZM16.3482 9.54492C17.7431 9.54492 18.8584 9.09141 19.6758 8.18174C20.451 7.31426 20.8359 6.18311 20.8359 4.78564C20.8359 3.38555 20.451 2.24121 19.6758 1.37637C18.861 0.458789 17.7457 0 16.3482 0C14.9323 0 13.8196 0.461425 13.0181 1.39219C12.2481 2.26494 11.8737 3.39346 11.8737 4.78564C11.8737 6.16728 12.2508 7.2958 13.0207 8.16855C13.8275 9.0835 14.9455 9.54492 16.3482 9.54492ZM14.463 2.59189C14.9086 2.04873 15.5256 1.77715 16.3456 1.77715C17.1762 1.77715 17.7905 2.03027 18.2177 2.54443C18.6501 3.07969 18.8742 3.82588 18.8742 4.78301C18.8742 5.74014 18.6527 6.47314 18.2203 6.99521C17.7853 7.50674 17.1656 7.76514 16.3456 7.76514C15.5229 7.76514 14.8954 7.49355 14.463 6.96357C14.0332 6.43359 13.817 5.71641 13.817 4.78564C13.8196 3.8417 14.0332 3.12451 14.463 2.59189Z"
        fill="#03B0F7"
      />
    </svg>
  );
};

// Excel
export const IconExcel = (props) => (
  <svg
    className="text-sm cursor-pointer"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.7905 7.67501L4.256 6.70001V13.9045C4.25606 13.9828 4.27154 14.0603 4.30156 14.1326C4.33157 14.2048 4.37552 14.2705 4.43091 14.3258C4.4863 14.3811 4.55204 14.4249 4.62438 14.4548C4.69671 14.4847 4.77423 14.5001 4.8525 14.5H14.4025C14.4808 14.5002 14.5585 14.485 14.6309 14.4551C14.7034 14.4253 14.7692 14.3815 14.8247 14.3262C14.8802 14.2708 14.9243 14.2051 14.9543 14.1328C14.9844 14.0604 14.9999 13.9829 15 13.9045V11.25L9.7905 7.67501Z"
      fill="#185C37"
    />
    <path
      d="M9.7905 1.5H4.8525C4.77423 1.49993 4.69671 1.51529 4.62438 1.54518C4.55204 1.57507 4.4863 1.61891 4.43091 1.67421C4.37552 1.72951 4.33157 1.79517 4.30156 1.86746C4.27154 1.93974 4.25606 2.01723 4.256 2.0955V4.75L9.7905 8L12.721 8.975L15 8V4.75L9.7905 1.5Z"
      fill="#21A366"
    />
    <path d="M4.256 4.75H9.7905V8H4.256V4.75Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M8.217 4.09998H4.256V12.225H8.217C8.37483 12.2242 8.526 12.1612 8.63774 12.0498C8.74949 11.9383 8.81281 11.7873 8.814 11.6295V4.69548C8.81281 4.53764 8.74949 4.38664 8.63774 4.27517C8.526 4.16371 8.37483 4.10076 8.217 4.09998V4.09998Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.8915 4.42499H4.256V12.55H7.8915C8.04933 12.5492 8.2005 12.4863 8.31224 12.3748C8.42399 12.2633 8.48731 12.1123 8.4885 11.9545V5.02049C8.48731 4.86266 8.42399 4.71165 8.31224 4.60018C8.2005 4.48872 8.04933 4.42577 7.8915 4.42499V4.42499Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.8915 4.42499H4.256V11.9H7.8915C8.04933 11.8992 8.2005 11.8363 8.31224 11.7248C8.42399 11.6133 8.48731 11.4623 8.4885 11.3045V5.02049C8.48731 4.86266 8.42399 4.71165 8.31224 4.60018C8.2005 4.48872 8.04933 4.42577 7.8915 4.42499V4.42499Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.566 4.42499H4.256V11.9H7.566C7.72383 11.8992 7.875 11.8363 7.98674 11.7248C8.09849 11.6133 8.16181 11.4623 8.163 11.3045V5.02049C8.16181 4.86266 8.09849 4.71165 7.98674 4.60018C7.875 4.48872 7.72383 4.42577 7.566 4.42499V4.42499Z"
      fill="black"
    />
    <path
      d="M1.597 4.42499H7.566C7.72412 4.42486 7.87581 4.48751 7.98776 4.59917C8.0997 4.71083 8.16274 4.86237 8.163 5.02049V10.9795C8.16274 11.1376 8.0997 11.2891 7.98776 11.4008C7.87581 11.5125 7.72412 11.5751 7.566 11.575H1.597C1.51869 11.5751 1.44112 11.5598 1.36873 11.53C1.29634 11.5001 1.23054 11.4563 1.17509 11.401C1.11965 11.3457 1.07565 11.28 1.04561 11.2076C1.01556 11.1353 1.00007 11.0578 1 10.9795V5.02049C1.00007 4.94218 1.01556 4.86465 1.04561 4.79233C1.07565 4.72001 1.11965 4.65433 1.17509 4.59902C1.23054 4.54372 1.29634 4.49988 1.36873 4.47002C1.44112 4.44016 1.51869 4.42486 1.597 4.42499V4.42499Z"
      fill="url(#paint0_linear_50_2920)"
    />
    <path
      d="M2.85 9.93648L4.1055 7.99448L2.9555 6.06348H3.879L4.5065 7.29998C4.5645 7.41698 4.6065 7.50398 4.6255 7.56198H4.634C4.675 7.46798 4.7185 7.37748 4.764 7.28898L5.435 6.06548H6.285L5.1055 7.98548L6.315 9.93798H5.4105L4.6855 8.58248C4.65184 8.5242 4.62323 8.46314 4.6 8.39998H4.588C4.56686 8.46152 4.53867 8.52041 4.504 8.57548L3.7575 9.93648H2.85Z"
      fill="white"
    />
    <path
      d="M14.403 1.5H9.7905V4.75H15V2.0955C14.9999 2.01719 14.9844 1.93966 14.9544 1.86734C14.9243 1.79503 14.8803 1.72934 14.8249 1.67403C14.7695 1.61873 14.7037 1.5749 14.6313 1.54503C14.5589 1.51517 14.4813 1.49987 14.403 1.5V1.5Z"
      fill="#33C481"
    />
    <path d="M9.7905 8H15V11.25H9.7905V8Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="paint0_linear_50_2920"
        x1="2.247"
        y1="3.95699"
        x2="6.916"
        y2="12.043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
);

export const IconLT = ({ active, stroke }) => {
  if (active) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          fill="white"
          stroke={stroke || "#03B0F7"}
        />
        <path
          d="M10 2.5C6.72505 2.5 3.95005 4.6 2.92505 7.5H17.075C16.05 4.6 13.275 2.5 10 2.5Z"
          fill="#FFCE31"
        />
        <path
          d="M10 17.5C13.275 17.5 16.05 15.425 17.075 12.5H2.92505C3.95005 15.425 6.72505 17.5 10 17.5Z"
          fill="#C94747"
        />
        <path
          d="M2.925 7.5C2.65 8.275 2.5 9.125 2.5 10C2.5 10.875 2.65 11.725 2.925 12.5H17.075C17.35 11.725 17.5 10.875 17.5 10C17.5 9.125 17.35 8.275 17.075 7.5H2.925Z"
          fill="#699635"
        />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="text-sm cursor-pointer"
    >
      <path
        d="M8.00005 0.5C4.72505 0.5 1.95005 2.6 0.925049 5.5H15.075C14.05 2.6 11.275 0.5 8.00005 0.5Z"
        fill="#FFCE31"
      />
      <path
        d="M8.00005 15.5C11.275 15.5 14.05 13.425 15.075 10.5H0.925049C1.95005 13.425 4.72505 15.5 8.00005 15.5Z"
        fill="#C94747"
      />
      <path
        d="M0.925 5.5C0.65 6.275 0.5 7.125 0.5 8C0.5 8.875 0.65 9.725 0.925 10.5H15.075C15.35 9.725 15.5 8.875 15.5 8C15.5 7.125 15.35 6.275 15.075 5.5H0.925Z"
        fill="#699635"
      />
    </svg>
  );
};

export const IconEE = ({ active, stroke }) => {
  if (active) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          fill="white"
          stroke={stroke || "#03B0F7"}
        />
        <path
          d="M10 2.5C6.72505 2.5 3.95005 4.6 2.92505 7.5H17.075C16.05 4.6 13.275 2.5 10 2.5Z"
          fill="#42ADE2"
        />
        <path
          d="M10 17.5C13.275 17.5 16.05 15.425 17.075 12.5H2.92505C3.95005 15.425 6.72505 17.5 10 17.5Z"
          fill="#F9F9F9"
        />
        <path
          d="M2.925 7.5C2.65 8.275 2.5 9.125 2.5 10C2.5 10.875 2.65 11.725 2.925 12.5H17.075C17.35 11.725 17.5 10.875 17.5 10C17.5 9.125 17.35 8.275 17.075 7.5H2.925Z"
          fill="#3E4347"
        />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="text-sm cursor-pointer"
    >
      <path
        d="M8.00005 15.5C11.2751 15.5 14.05 13.425 15.0751 10.5H0.925049C1.95005 13.425 4.72505 15.5 8.00005 15.5Z"
        fill="#F9F9F9"
      />
      <path
        d="M8.00005 0.5C4.72505 0.5 1.95005 2.6 0.925049 5.5H15.0751C14.05 2.6 11.2751 0.5 8.00005 0.5Z"
        fill="#42ADE2"
      />
      <path
        d="M15.075 10.5C15.35 9.725 15.5 8.875 15.5 8C15.5 7.125 15.35 6.275 15.075 5.5H0.925C0.65 6.275 0.5 7.125 0.5 8C0.5 8.875 0.65 9.725 0.925 10.5H15.075Z"
        fill="#3E4347"
      />
    </svg>
  );
};

export const IconLV = ({ active, stroke }) => {
  if (active) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          fill="white"
          stroke={stroke || "#03B0F7"}
        />
        <path
          d="M10 2.5C6.72505 2.5 3.95005 4.6 2.92505 7.5H17.075C16.05 4.6 13.275 2.5 10 2.5Z"
          fill="#C94747"
        />
        <path
          d="M10 17.5C13.275 17.5 16.05 15.425 17.075 12.5H2.92505C3.95005 15.425 6.72505 17.5 10 17.5Z"
          fill="#C94747"
        />
        <path
          d="M2.925 7.5C2.65 8.275 2.5 9.125 2.5 10C2.5 10.875 2.65 11.725 2.925 12.5H17.075C17.35 11.725 17.5 10.875 17.5 10C17.5 9.125 17.35 8.275 17.075 7.5H2.925Z"
          fill="#fff"
        />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.2999 9.75V6.25C14.4999 2.95 11.5499 0.5 7.99995 0.5C4.44995 0.5 1.49995 2.95 0.699951 6.25V9.75C1.49995 13.05 4.44995 15.5 7.99995 15.5C11.5499 15.5 14.4999 13.05 15.2999 9.75Z"
        fill="#C94747"
      />
      <path
        opacity="0.15"
        d="M15.2999 9.75V6.25C14.4999 2.95 11.5499 0.5 7.99995 0.5C4.44995 0.5 1.49995 2.95 0.699951 6.25V9.75C1.49995 13.05 4.44995 15.5 7.99995 15.5C11.5499 15.5 14.4999 13.05 15.2999 9.75Z"
        fill="#C28FEF"
      />
      <path
        d="M0.5 8C0.5 8.6 0.575 9.2 0.7 9.75H15.275C15.4 9.2 15.475 8.6 15.475 8C15.475 7.4 15.4 6.8 15.275 6.25H0.7C0.575 6.8 0.5 7.4 0.5 8Z"
        fill="white"
      />
    </svg>
  );
};

export const IconBlockSuccess = (props) => {
  return (
    <svg
      style={{
        height: 16,
        width: 15,
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 0C2.38805 0 1.5614 0.34241 0.951903 0.951903C0.34241 1.5614 0 2.38805 0 3.25V9.75C0 10.612 0.34241 11.4386 0.951903 12.0481C1.5614 12.6576 2.38805 13 3.25 13H9.75C10.612 13 11.4386 12.6576 12.0481 12.0481C12.6576 11.4386 13 10.612 13 9.75V3.25C13 2.38805 12.6576 1.5614 12.0481 0.951903C11.4386 0.34241 10.612 0 9.75 0H3.25ZM8.9245 5.6446C8.98289 5.58229 9.02843 5.50909 9.05852 5.42917C9.08862 5.34926 9.10268 5.2642 9.0999 5.17886C9.09713 5.09351 9.07757 5.00955 9.04234 4.93176C9.00711 4.85397 8.95691 4.78389 8.8946 4.7255C8.83229 4.66711 8.75909 4.62157 8.67917 4.59148C8.59926 4.56138 8.5142 4.54732 8.42886 4.5501C8.34351 4.55287 8.25955 4.57243 8.18176 4.60766C8.10397 4.64289 8.03389 4.69309 7.9755 4.7554L5.97155 6.8939L4.9816 6.01445C4.8519 5.90663 4.68536 5.85344 4.51717 5.86613C4.34899 5.87882 4.19232 5.95639 4.08026 6.08245C3.9682 6.20852 3.90954 6.3732 3.91666 6.54172C3.92377 6.71023 3.99611 6.86938 4.1184 6.98555L5.5809 8.28555C5.70745 8.39796 5.87285 8.45657 6.04194 8.44892C6.21103 8.44128 6.37047 8.36797 6.48635 8.2446L8.92385 5.6446H8.9245Z"
        fill="#699635"
      />
    </svg>
  );
};

export const IconBlockDenied = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      {...props}
    >
      <path
        d="M4.40625 11.3438C4.57812 11.5156 4.79687 11.6016 5.0625 11.6016C5.32812 11.6016 5.54688 11.5156 5.71875 11.3438L7.5 9.5625L9.30469 11.3672C9.47656 11.5391 9.6875 11.625 9.9375 11.625C10.1875 11.625 10.4062 11.5312 10.5938 11.3438C10.7656 11.1719 10.8516 10.9531 10.8516 10.6875C10.8516 10.4219 10.7656 10.2031 10.5938 10.0312L8.8125 8.25L10.6172 6.44531C10.7891 6.27344 10.875 6.0625 10.875 5.8125C10.875 5.5625 10.7812 5.34375 10.5938 5.15625C10.4219 4.98438 10.2031 4.89844 9.9375 4.89844C9.67188 4.89844 9.45312 4.98438 9.28125 5.15625L7.5 6.9375L5.69531 5.13281C5.52344 4.96094 5.3125 4.875 5.0625 4.875C4.8125 4.875 4.59375 4.96875 4.40625 5.15625C4.23438 5.32812 4.14844 5.54687 4.14844 5.8125C4.14844 6.07812 4.23438 6.29688 4.40625 6.46875L6.1875 8.25L4.38281 10.0547C4.21094 10.2266 4.125 10.4375 4.125 10.6875C4.125 10.9375 4.21875 11.1562 4.40625 11.3438ZM1.875 15.75C1.35938 15.75 0.918125 15.5666 0.55125 15.1997C0.18375 14.8322 0 14.3906 0 13.875V2.625C0 2.10938 0.18375 1.66812 0.55125 1.30125C0.918125 0.93375 1.35938 0.75 1.875 0.75H13.125C13.6406 0.75 14.0822 0.93375 14.4497 1.30125C14.8166 1.66812 15 2.10938 15 2.625V13.875C15 14.3906 14.8166 14.8322 14.4497 15.1997C14.0822 15.5666 13.6406 15.75 13.125 15.75H1.875Z"
        fill="#BFBFBF"
      />
    </svg>
  );
};

export const IconBlockApply = (props) => {
  return (
    <svg
      style={{
        height: 16,
        width: 15,
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M11.375 0C11.806 0 12.2193 0.171205 12.524 0.475951C12.8288 0.780698 13 1.19402 13 1.625V11.375C13 11.806 12.8288 12.2193 12.524 12.524C12.2193 12.8288 11.806 13 11.375 13H1.625C1.19402 13 0.780698 12.8288 0.475951 12.524C0.171205 12.2193 0 11.806 0 11.375V1.625C0 1.19402 0.171205 0.780698 0.475951 0.475951C0.780698 0.171205 1.19402 0 1.625 0L11.375 0ZM4.797 8.77744L8.125 5.44944V7.69844C8.125 7.80618 8.1678 7.90951 8.24399 7.9857C8.32017 8.06189 8.42351 8.10469 8.53125 8.10469C8.63899 8.10469 8.74233 8.06189 8.81851 7.9857C8.8947 7.90951 8.9375 7.80618 8.9375 7.69844V4.46875C8.9375 4.36101 8.8947 4.25767 8.81851 4.18149C8.74233 4.1053 8.63899 4.0625 8.53125 4.0625H5.30156C5.19382 4.0625 5.09049 4.1053 5.0143 4.18149C4.93811 4.25767 4.89531 4.36101 4.89531 4.46875C4.89531 4.57649 4.93811 4.67983 5.0143 4.75601C5.09049 4.8322 5.19382 4.875 5.30156 4.875H7.55056L4.22256 8.203C4.14856 8.27962 4.10761 8.38224 4.10854 8.48876C4.10946 8.59527 4.15219 8.69717 4.22751 8.77249C4.30283 8.84781 4.40473 8.89054 4.51124 8.89146C4.61776 8.89239 4.72038 8.85144 4.797 8.77744Z"
        fill="#03B0F7"
      />
    </svg>
  );
};

export const IconRefresh = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      {...props}
    >
      <path d="M2.40533 7.21305C2.47318 5.95649 2.99716 4.7862 3.89434 3.88972C4.85183 2.93323 6.15612 2.39685 7.5132 2.39685C8.8778 2.39685 10.1633 2.92573 11.132 3.88972C11.1848 3.94223 11.2338 3.99475 11.2866 4.05101L10.3442 4.7862C10.2993 4.82076 10.2651 4.86723 10.2456 4.92026C10.226 4.9733 10.2219 5.03074 10.2337 5.08599C10.2456 5.14124 10.2728 5.19205 10.3124 5.23258C10.3519 5.2731 10.4021 5.3017 10.4573 5.31508L14.1591 6.2153C14.3476 6.26031 14.5323 6.11778 14.5323 5.92648L14.5511 2.12678C14.5511 1.87547 14.2646 1.73293 14.0648 1.89047L13.1903 2.57314C11.8106 0.99775 9.78252 0 7.51696 0C3.46837 0 0.166164 3.19205 0.000299555 7.19055C-0.00723973 7.35934 0.128467 7.50187 0.301871 7.50187H2.10753C2.26585 7.49812 2.39779 7.37434 2.40533 7.21305ZM14.6981 7.49812H12.8925C12.7341 7.49812 12.6022 7.6219 12.5909 7.7832C12.523 9.03976 11.9991 10.2101 11.1019 11.1065C10.1444 12.063 8.84011 12.5994 7.48304 12.5994C6.11843 12.5994 4.83298 12.0705 3.86418 11.1065C3.81141 11.054 3.7624 11.0015 3.70963 10.9452L4.65204 10.2101C4.69694 10.1755 4.73112 10.129 4.75066 10.076C4.7702 10.023 4.7743 9.96551 4.76248 9.91026C4.75067 9.85501 4.72342 9.8042 4.68388 9.76367C4.64434 9.72315 4.5941 9.69455 4.53895 9.68117L0.837159 8.78095C0.648677 8.73593 0.463965 8.87847 0.463965 9.06977L0.448887 12.8732C0.448887 13.1245 0.735379 13.2671 0.93517 13.1095L1.80973 12.4269C3.18942 14.0023 5.21748 15 7.48304 15C11.5316 15 14.8338 11.808 14.9997 7.80945C15.0072 7.64066 14.8715 7.49812 14.6981 7.49812Z" />
    </svg>
  );
};

// Clouc icon

export const IconCloudSync = (props) => {
  return (
    <svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.6781 3.44816C10.9625 1.43326 9.13904 0 7.00312 0C4.86719 0 3.04377 1.4316 2.32815 3.4465C0.98285 3.82481 -0.00776655 5.13641 4.58863e-05 6.693C0.00942081 8.43292 1.27504 9.84785 2.86877 9.99951C2.94221 10.0062 3.00471 9.94451 3.00471 9.86618V8.85956C3.00471 8.7929 2.95783 8.73623 2.89534 8.7279C2.47346 8.67124 2.07503 8.47458 1.76878 8.15293C1.39378 7.76128 1.18754 7.23464 1.18754 6.67634C1.18754 6.20969 1.32972 5.76971 1.59691 5.40307C1.85784 5.04642 2.22503 4.7881 2.62971 4.67477L3.2219 4.50811L3.43908 3.89647C3.57345 3.51649 3.76095 3.15984 3.99689 2.83819C4.2297 2.51821 4.50626 2.23822 4.81563 2.0049C5.45781 1.52326 6.21406 1.26827 7.00312 1.26827C7.79217 1.26827 8.54842 1.52326 9.1906 2.00657C9.50153 2.23989 9.77653 2.51988 10.0093 2.83986C10.2453 3.16151 10.4328 3.51816 10.5671 3.89814L10.7828 4.50811L11.3734 4.67477C12.2203 4.91476 12.8124 5.73638 12.8124 6.67467C12.8124 7.23464 12.6062 7.75962 12.2312 8.15126C11.9265 8.47125 11.5296 8.66957 11.1078 8.72623C11.0453 8.73457 11 8.79123 11 8.85789V9.86618C11 9.94451 11.064 10.0062 11.1375 9.99951C12.7265 9.84618 13.989 8.43292 13.9999 6.69634C14.0093 5.13975 13.0203 3.82814 11.6781 3.44816Z"
        fill="#727272"
      />
      <path
        d="M4.96213 7.88522C4.98927 7.3826 5.19887 6.91448 5.55774 6.55589C5.94073 6.17329 6.46245 5.95874 7.00528 5.95874C7.55112 5.95874 8.0653 6.17029 8.45282 6.55589C8.47393 6.57689 8.49353 6.5979 8.51464 6.6204L8.13768 6.91448C8.11972 6.9283 8.10604 6.94689 8.09823 6.96811C8.09041 6.98932 8.08877 7.0123 8.0935 7.0344C8.09822 7.0565 8.10912 7.07682 8.12494 7.09303C8.14076 7.10924 8.16085 7.12068 8.18291 7.12603L9.66363 7.48612C9.73902 7.50413 9.81291 7.44711 9.81291 7.37059L9.82044 5.85071C9.82044 5.75019 9.70585 5.69317 9.62593 5.75619L9.27611 6.02926C8.72423 5.3991 7.91301 5 7.00679 5C5.38735 5 4.06647 6.27682 4.00012 7.87622C3.9971 7.94374 4.05139 8.00075 4.12075 8.00075H4.84301C4.90634 7.99925 4.95912 7.94974 4.96213 7.88522ZM9.87925 7.99925H9.15699C9.09366 7.99925 9.04088 8.04876 9.03636 8.11328C9.00922 8.6159 8.79963 9.08402 8.44076 9.44261C8.05776 9.82521 7.53604 10.0398 6.99321 10.0398C6.44737 10.0398 5.93319 9.82821 5.54567 9.44261C5.52456 9.42161 5.50496 9.4006 5.48385 9.37809L5.86081 9.08402C5.87877 9.0702 5.89245 9.05161 5.90026 9.03039C5.90808 9.00918 5.90972 8.9862 5.90499 8.9641C5.90027 8.942 5.88937 8.92168 5.87355 8.90547C5.85773 8.88926 5.83764 8.87782 5.81558 8.87247L4.33486 8.51238C4.25947 8.49437 4.18559 8.55139 4.18559 8.62791L4.17955 10.1493C4.17955 10.2498 4.29415 10.3068 4.37407 10.2438L4.72389 9.97074C5.27577 10.6009 6.08699 11 6.99321 11C8.61265 11 9.93353 9.72318 9.99988 8.12378C10.0029 8.05626 9.94861 7.99925 9.87925 7.99925Z"
        fill="#727272"
      />
    </svg>
  );
};

export const IconPlayRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="7"
    viewBox="0 0 4 7"
    fill="none"
    {...props}
  >
    <path
      d="M3.57908 3.88926L0.831108 6.37097C0.507788 6.66385 1.81078e-07 6.42582 1.61648e-07 5.98133L-5.53099e-08 1.0179C-8.26828e-05 0.918421 0.0276137 0.821027 0.0797725 0.737381C0.131931 0.653734 0.206342 0.58738 0.294092 0.546265C0.381843 0.50515 0.479214 0.491017 0.574546 0.505558C0.669877 0.5201 0.759127 0.562699 0.831609 0.628255L3.57857 3.10997C3.63242 3.15854 3.67557 3.21844 3.70514 3.28564C3.7347 3.35285 3.75 3.4258 3.75 3.49961C3.75 3.57342 3.7347 3.64638 3.70514 3.71359C3.67557 3.78079 3.63242 3.84069 3.57858 3.88926L3.57908 3.88926Z"
      fill="#5F5F5F"
    />
  </svg>
);

export const IconPlayLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="7"
    viewBox="0 0 4 7"
    fill="none"
    {...props}
  >
    <path
      d="M0.420923 3.11074L3.16889 0.629028C3.49221 0.336148 4 0.574178 4 1.01867L4 5.9821C4.00008 6.08158 3.97239 6.17897 3.92023 6.26262C3.86807 6.34627 3.79366 6.41262 3.70591 6.45373C3.61816 6.49485 3.52079 6.50898 3.42545 6.49444C3.33012 6.4799 3.24087 6.4373 3.16839 6.37174L0.421425 3.89003C0.367584 3.84146 0.324431 3.78156 0.294864 3.71436C0.265297 3.64715 0.25 3.5742 0.25 3.50039C0.25 3.42658 0.265297 3.35362 0.294864 3.28641C0.324431 3.21921 0.367584 3.15931 0.421425 3.11074L0.420923 3.11074Z"
      fill="#5F5F5F"
    />
  </svg>
);

export const IconTechnorama = (props) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00583 12.0468C4.39023 12.0468 2.87999 11.4146 1.75609 10.2907C0.632192 9.16679 0 7.65655 0 6.04095C0 4.42535 0.632192 2.91511 1.75609 1.79121C2.17755 1.36975 2.91511 1.36975 3.33657 1.79121C3.75803 2.21267 3.75803 2.95023 3.33657 3.37169C2.63414 4.07413 2.21267 5.02242 2.21267 6.04095C2.21267 7.05948 2.59901 8.00777 3.33657 8.71021C4.03901 9.41264 4.9873 9.8341 6.00583 9.8341C7.02436 9.8341 7.97265 9.44776 8.67509 8.71021C9.37752 8.00777 9.79899 7.05948 9.79899 6.04095C9.79899 5.02242 9.41265 4.07413 8.67509 3.37169C8.25363 2.95023 8.25363 2.21267 8.67509 1.79121C9.09655 1.36975 9.83411 1.36975 10.2556 1.79121C11.3795 2.91511 12.0117 4.42535 12.0117 6.04095C12.0117 7.65655 11.3795 9.16679 10.2556 10.2907C9.13167 11.4146 7.62143 12.0468 6.00583 12.0468Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00573 7.12973C5.37354 7.12973 4.88184 6.63802 4.88184 6.00583V1.1239C4.88184 0.491706 5.37354 0 6.00573 0C6.63793 0 7.12963 0.491706 7.12963 1.1239V6.00583C7.12963 6.63802 6.63793 7.12973 6.00573 7.12973Z"
      fill="black"
    />
  </svg>
);

export const IconEmailAlert = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 9 9"
    fill="none"
    {...props}
  >
    <path
      d="M2.72654 6.03789C2.86618 6.53453 3.31668 6.92857 3.89832 6.92857H7.53571V7.53571C7.53571 7.85776 7.40778 8.16662 7.18006 8.39434C6.95234 8.62206 6.64348 8.75 6.32143 8.75H1.46429C1.14224 8.75 0.833379 8.62206 0.605656 8.39434C0.377933 8.16662 0.25 7.85776 0.25 7.53571V4.7046L2.72654 6.03789ZM4.05618 2.67857L2.81154 5.17028C2.78118 5.231 2.75629 5.29232 2.73686 5.35424L0.25 4.01428V3.89285C0.25 3.5708 0.377933 3.26195 0.605656 3.03422C0.833379 2.8065 1.14224 2.67857 1.46429 2.67857H4.05557H4.05618ZM3.35007 5.44228L5.47264 1.19349C5.523 1.09246 5.60052 1.00747 5.69651 0.948059C5.7925 0.88865 5.90315 0.857178 6.01604 0.857178C6.12892 0.857178 6.23957 0.88865 6.33556 0.948059C6.43155 1.00747 6.50907 1.09246 6.55943 1.19349L8.68443 5.44228C8.73081 5.53484 8.75275 5.63773 8.74817 5.74117C8.74359 5.8446 8.71263 5.94514 8.65823 6.03324C8.60384 6.12134 8.52783 6.19406 8.43741 6.2445C8.34699 6.29494 8.24518 6.32142 8.14164 6.32142H3.89407C3.79048 6.32152 3.6886 6.29512 3.5981 6.24472C3.5076 6.19432 3.43149 6.12161 3.37703 6.0335C3.32257 5.94538 3.29156 5.8448 3.28694 5.74132C3.28233 5.63783 3.30427 5.53489 3.35068 5.44228H3.35007ZM6.01543 2.06839C5.93492 2.06839 5.8577 2.10037 5.80077 2.1573C5.74384 2.21423 5.71186 2.29145 5.71186 2.37196V4.1946C5.71186 4.27519 5.74387 4.35249 5.80086 4.40947C5.85785 4.46646 5.93514 4.49848 6.01573 4.49848C6.09632 4.49848 6.17362 4.46646 6.2306 4.40947C6.28759 4.35249 6.31961 4.27519 6.31961 4.1946V2.37196C6.31961 2.29145 6.28762 2.21423 6.23069 2.1573C6.17376 2.10037 6.09655 2.06839 6.01604 2.06839H6.01543ZM6.31961 5.4101C6.31961 5.32959 6.28762 5.25238 6.23069 5.19544C6.17376 5.13851 6.09655 5.10653 6.01604 5.10653C5.93552 5.10653 5.85831 5.13851 5.80138 5.19544C5.74445 5.25238 5.71246 5.32959 5.71246 5.4101C5.71246 5.49061 5.74445 5.56783 5.80138 5.62476C5.85831 5.68169 5.93552 5.71367 6.01604 5.71367C6.09655 5.71367 6.17376 5.68169 6.23069 5.62476C6.28762 5.56783 6.31961 5.49061 6.31961 5.4101Z"
      fill="#F29302"
    />
  </svg>
);

export const Icon3Dots = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="14"
    viewBox="0 0 4 14"
    fill="none"
    {...props}
  >
    <path
      d="M3.5 12C3.5 12.3978 3.34196 12.7794 3.06066 13.0607C2.77936 13.342 2.39782 13.5 2 13.5C1.60218 13.5 1.22064 13.342 0.93934 13.0607C0.658035 12.7794 0.5 12.3978 0.5 12C0.5 11.6022 0.658035 11.2206 0.93934 10.9393C1.22064 10.658 1.60218 10.5 2 10.5C2.39782 10.5 2.77936 10.658 3.06066 10.9393C3.34196 11.2206 3.5 11.6022 3.5 12ZM3.5 7C3.5 7.39782 3.34196 7.77936 3.06066 8.06066C2.77936 8.34196 2.39782 8.5 2 8.5C1.60218 8.5 1.22064 8.34196 0.93934 8.06066C0.658035 7.77936 0.5 7.39782 0.5 7C0.5 6.60218 0.658035 6.22064 0.93934 5.93934C1.22064 5.65804 1.60218 5.5 2 5.5C2.39782 5.5 2.77936 5.65804 3.06066 5.93934C3.34196 6.22064 3.5 6.60218 3.5 7ZM3.5 2C3.5 2.39782 3.34196 2.77936 3.06066 3.06066C2.77936 3.34196 2.39782 3.5 2 3.5C1.60218 3.5 1.22064 3.34196 0.93934 3.06066C0.658035 2.77936 0.5 2.39782 0.5 2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5C2.39782 0.5 2.77936 0.658035 3.06066 0.93934C3.34196 1.22064 3.5 1.60218 3.5 2Z"
      fill="#C4C4C4"
    />
  </svg>
);

export const IconColumnSpacing = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00002 1.5C8.00002 1.36739 7.94734 1.24021 7.85357 1.14645C7.7598 1.05268 7.63263 1 7.50002 1C7.36741 1 7.24023 1.05268 7.14647 1.14645C7.0527 1.24021 7.00002 1.36739 7.00002 1.5V13.5C7.00002 13.6326 7.0527 13.7598 7.14647 13.8536C7.24023 13.9473 7.36741 14 7.50002 14C7.63263 14 7.7598 13.9473 7.85357 13.8536C7.94734 13.7598 8.00002 13.6326 8.00002 13.5V1.5ZM3.31802 5.818C3.36223 5.7768 3.39769 5.72712 3.42229 5.67192C3.44688 5.61672 3.46011 5.55714 3.46117 5.49671C3.46224 5.43629 3.45113 5.37627 3.42849 5.32024C3.40586 5.26421 3.37217 5.21331 3.32944 5.17058C3.28671 5.12785 3.23581 5.09416 3.17978 5.07153C3.12374 5.04889 3.06373 5.03778 3.00331 5.03885C2.94288 5.03991 2.8833 5.05314 2.8281 5.07773C2.7729 5.10233 2.72322 5.13779 2.68202 5.182L0.682019 7.182C0.597749 7.26638 0.550415 7.38075 0.550415 7.5C0.550415 7.61925 0.597749 7.73362 0.682019 7.818L2.68202 9.818C2.72322 9.86221 2.7729 9.89767 2.8281 9.92227C2.8833 9.94686 2.94288 9.96009 3.00331 9.96115C3.06373 9.96222 3.12374 9.95111 3.17978 9.92847C3.23581 9.90584 3.28671 9.87215 3.32944 9.82942C3.37217 9.78669 3.40586 9.73579 3.42849 9.67976C3.45113 9.62373 3.46224 9.56371 3.46117 9.50329C3.46011 9.44286 3.44688 9.38328 3.42229 9.32808C3.39769 9.27288 3.36223 9.2232 3.31802 9.182L2.08602 7.95H5.50002C5.61937 7.95 5.73383 7.90259 5.81822 7.8182C5.90261 7.73381 5.95002 7.61935 5.95002 7.5C5.95002 7.38065 5.90261 7.26619 5.81822 7.1818C5.73383 7.09741 5.61937 7.05 5.50002 7.05H2.08602L3.31802 5.818ZM12.318 5.182C12.2768 5.13779 12.2271 5.10233 12.1719 5.07773C12.1167 5.05314 12.0572 5.03991 11.9967 5.03885C11.9363 5.03778 11.8763 5.04889 11.8203 5.07153C11.7642 5.09416 11.7133 5.12785 11.6706 5.17058C11.6279 5.21331 11.5942 5.26421 11.5715 5.32024C11.5489 5.37627 11.5378 5.43629 11.5389 5.49671C11.5399 5.55714 11.5532 5.61672 11.5778 5.67192C11.6023 5.72712 11.6378 5.7768 11.682 5.818L12.914 7.05H9.50002C9.38067 7.05 9.26621 7.09741 9.18182 7.1818C9.09743 7.26619 9.05002 7.38065 9.05002 7.5C9.05002 7.61935 9.09743 7.73381 9.18182 7.8182C9.26621 7.90259 9.38067 7.95 9.50002 7.95H12.914L11.682 9.182C11.6025 9.26731 11.5593 9.38013 11.5613 9.49671C11.5634 9.61329 11.6106 9.72453 11.693 9.80697C11.7755 9.88942 11.8867 9.93665 12.0033 9.93871C12.1199 9.94076 12.2327 9.89749 12.318 9.818L14.318 7.818C14.4023 7.73362 14.4496 7.61925 14.4496 7.5C14.4496 7.38075 14.4023 7.26638 14.318 7.182L12.318 5.182Z"
      fill="#C4C4C4"
    />
  </svg>
);

export const IconDraggable = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
  >
    <path
      d="M0.25 6.25H3.6875V8.17812L2.87812 7.37187L2.4375 7.8125L4 9.375L5.5625 7.8125L5.12187 7.37187L4.3125 8.17812V6.25H7.75V5.625H0.25V6.25ZM2.4375 2.1875L2.87812 2.62812L3.6875 1.82187V3.75H0.25V4.375H7.75V3.75H4.3125V1.82187L5.12187 2.62812L5.5625 2.1875L4 0.625L2.4375 2.1875Z"
      fill="#929292"
    />
  </svg>
);

export const IconChevronCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M10.9999 20.1663C16.0625 20.1663 20.1666 16.0623 20.1666 10.9997C20.1666 5.93706 16.0625 1.83301 10.9999 1.83301C5.93731 1.83301 1.83325 5.93706 1.83325 10.9997C1.83325 16.0623 5.93731 20.1663 10.9999 20.1663Z"
      stroke="#AEAEAE"
    />
    {props.up ? (
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M14.6667 12.375L11.0001 8.70833L7.33341 12.375"
        stroke="#AEAEAE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ) : (
      <path
        d="M7.33325 9.625L10.9999 13.2917L14.6666 9.625"
        stroke="#AEAEAE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

// export const IconSetting = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="10"
//     height="10"
//     viewBox="0 0 10 10"
//     fill="none"
//   >
//     <g clipPath="url(#clip0_1_854)">
//       <path
//         d="M3.5875 9.16666C3.38418 9.16546 3.18675 9.09819 3.025 8.975L2.1625 8.33333C1.96346 8.17814 1.8314 7.95264 1.79343 7.70312C1.75546 7.45361 1.81447 7.19903 1.95833 6.99166C2.03445 6.87926 2.08283 6.75041 2.09949 6.61569C2.11615 6.48097 2.10061 6.34422 2.05417 6.21666L2.02917 6.15C1.99682 6.03454 1.93771 5.92834 1.85663 5.84002C1.77554 5.75169 1.67477 5.68374 1.5625 5.64166H1.49583C1.25245 5.55982 1.05117 5.38527 0.935711 5.15591C0.820253 4.92656 0.799933 4.66091 0.879166 4.41666L1.22083 3.33333C1.25228 3.20781 1.31019 3.09046 1.39067 2.98914C1.47115 2.88782 1.57236 2.80487 1.6875 2.74583C1.79473 2.69058 1.91205 2.65766 2.03237 2.64907C2.15269 2.64047 2.27351 2.65638 2.3875 2.69583C2.51162 2.7376 2.64406 2.74843 2.77331 2.72737C2.90257 2.70631 3.02473 2.654 3.12917 2.57499L3.18333 2.53333C3.27787 2.45789 3.35428 2.3622 3.40692 2.25331C3.45956 2.14442 3.4871 2.02511 3.4875 1.90416V1.80416C3.48638 1.54922 3.58602 1.30415 3.76473 1.12232C3.94344 0.940492 4.18674 0.836623 4.44167 0.833328H5.50417C5.6282 0.833662 5.75094 0.858497 5.86535 0.906405C5.97976 0.954312 6.08357 1.02435 6.17083 1.11249C6.35429 1.29907 6.45619 1.55084 6.45417 1.81249V1.92916C6.45205 2.04406 6.47697 2.15784 6.52691 2.26134C6.57685 2.36484 6.65041 2.45515 6.74167 2.52499L6.7875 2.55833C6.88102 2.62845 6.9901 2.67493 7.10546 2.69379C7.22081 2.71266 7.33902 2.70335 7.45 2.66666L7.59167 2.62083C7.71169 2.58104 7.8385 2.56584 7.96453 2.57612C8.09056 2.5864 8.21323 2.62196 8.32522 2.68068C8.43721 2.7394 8.53623 2.82007 8.61637 2.91788C8.69651 3.01569 8.75612 3.12864 8.79167 3.25L9.12083 4.29999C9.197 4.54266 9.17618 4.80539 9.06275 5.03303C8.94932 5.26067 8.7521 5.43551 8.5125 5.52083L8.42917 5.55C8.3066 5.59013 8.19576 5.65975 8.1064 5.75275C8.01704 5.84574 7.95189 5.95926 7.91667 6.08333C7.8835 6.19867 7.87564 6.31981 7.89362 6.43846C7.91159 6.55712 7.95499 6.67049 8.02083 6.77083L8.12917 6.92916C8.27283 7.13768 8.33129 7.39326 8.29255 7.6435C8.25382 7.89373 8.12082 8.11967 7.92083 8.275L7.08333 8.92083C6.98215 8.99821 6.8662 9.05406 6.74263 9.08494C6.61905 9.11582 6.49046 9.12108 6.36477 9.10039C6.23908 9.0797 6.11896 9.03351 6.0118 8.96465C5.90464 8.89579 5.81271 8.80572 5.74167 8.69999L5.69167 8.62916C5.62342 8.52661 5.53031 8.44301 5.42102 8.38618C5.31172 8.32935 5.18981 8.30113 5.06667 8.30416C4.94916 8.30721 4.83401 8.33783 4.73051 8.39356C4.62701 8.44929 4.53806 8.52857 4.47083 8.625L4.375 8.7625C4.30393 8.86896 4.21182 8.95975 4.10433 9.02926C3.99684 9.09877 3.87625 9.14553 3.75 9.16666C3.69596 9.17196 3.64154 9.17196 3.5875 9.16666ZM1.83333 4.84166C2.06862 4.92556 2.28093 5.06352 2.45317 5.24445C2.6254 5.42537 2.75277 5.6442 2.825 5.88333V5.93333C2.91497 6.18192 2.94451 6.44836 2.91119 6.71062C2.87786 6.97289 2.78262 7.22347 2.63333 7.44166C2.60698 7.47078 2.59239 7.50864 2.59239 7.54791C2.59239 7.58718 2.60698 7.62505 2.63333 7.65416L3.52917 8.33333C3.54085 8.34251 3.55437 8.34908 3.56881 8.35261C3.58325 8.35613 3.59827 8.35652 3.61287 8.35376C3.62748 8.351 3.64132 8.34514 3.65347 8.33659C3.66562 8.32803 3.67581 8.31698 3.68333 8.30416L3.77917 8.16666C3.9237 7.95782 4.11673 7.78713 4.34169 7.66924C4.56665 7.55135 4.81685 7.48976 5.07083 7.48976C5.32482 7.48976 5.57501 7.55135 5.79998 7.66924C6.02494 7.78713 6.21796 7.95782 6.3625 8.16666L6.4125 8.24166C6.43041 8.26708 6.45715 8.2849 6.4875 8.29166C6.50142 8.29372 6.51561 8.29293 6.52921 8.28935C6.54282 8.28577 6.55556 8.27947 6.56667 8.27083L7.425 7.62083C7.45504 7.59698 7.47481 7.56253 7.48024 7.52455C7.48566 7.48658 7.47633 7.44797 7.45417 7.41666L7.34583 7.25833C7.20467 7.0525 7.11155 6.81759 7.07333 6.57095C7.0351 6.32431 7.05276 6.07223 7.125 5.83333C7.19823 5.58223 7.33068 5.3524 7.51123 5.16315C7.69177 4.9739 7.91513 4.83078 8.1625 4.74583L8.24583 4.71666C8.28056 4.70275 8.30838 4.67566 8.32321 4.64132C8.33804 4.60697 8.33869 4.56815 8.325 4.53333L8 3.49583C7.9922 3.47768 7.98079 3.4613 7.96646 3.44769C7.95214 3.43408 7.93519 3.42352 7.91667 3.41666C7.9044 3.41044 7.89084 3.4072 7.87708 3.4072C7.86333 3.4072 7.84977 3.41044 7.8375 3.41666L7.69583 3.4625C7.45619 3.54159 7.20092 3.5613 6.95197 3.51993C6.70302 3.47856 6.46785 3.37735 6.26667 3.22499L6.25 3.1875C6.05695 3.0413 5.90042 2.85233 5.7927 2.63545C5.68498 2.41856 5.629 2.17966 5.62917 1.9375V1.80833C5.62992 1.76817 5.61497 1.7293 5.5875 1.69999C5.56353 1.67833 5.53231 1.66644 5.5 1.66666H4.44167C4.42469 1.66772 4.40809 1.67212 4.39282 1.67961C4.37755 1.6871 4.36392 1.69754 4.35269 1.71031C4.34146 1.72309 4.33287 1.73796 4.3274 1.75406C4.32193 1.77017 4.3197 1.78719 4.32083 1.80416V1.90833C4.32086 2.15709 4.26377 2.40255 4.15396 2.62577C4.04416 2.84899 3.88457 3.04402 3.6875 3.19583L3.63333 3.2375C3.42072 3.39937 3.17155 3.50647 2.90779 3.54934C2.64403 3.59221 2.37377 3.56954 2.12083 3.48333C2.10191 3.47698 2.08142 3.47698 2.0625 3.48333C2.03898 3.49761 2.02127 3.51975 2.0125 3.54583L1.66667 4.63333C1.65461 4.67037 1.65744 4.71064 1.67454 4.74563C1.69165 4.78063 1.7217 4.80759 1.75833 4.82083L1.83333 4.84166Z"
//         fill="#999999"
//       />
//       <path
//         d="M5 6.45834C4.71157 6.45834 4.42961 6.37281 4.18979 6.21257C3.94997 6.05232 3.76305 5.82456 3.65267 5.55809C3.5423 5.29161 3.51342 4.99839 3.56969 4.7155C3.62596 4.43261 3.76485 4.17276 3.9688 3.96881C4.17275 3.76486 4.4326 3.62596 4.71549 3.56969C4.99838 3.51342 5.2916 3.5423 5.55808 3.65268C5.82455 3.76306 6.05231 3.94998 6.21256 4.1898C6.3728 4.42962 6.45833 4.71157 6.45833 5.00001C6.45833 5.38678 6.30469 5.75771 6.0312 6.0312C5.7577 6.30469 5.38677 6.45834 5 6.45834ZM5 4.37501C4.87638 4.37501 4.75555 4.41166 4.65277 4.48034C4.54999 4.54901 4.46988 4.64662 4.42257 4.76083C4.37527 4.87503 4.36289 5.0007 4.38701 5.12194C4.41112 5.24318 4.47065 5.35454 4.55806 5.44195C4.64546 5.52936 4.75683 5.58888 4.87807 5.613C4.9993 5.63711 5.12497 5.62474 5.23918 5.57743C5.35338 5.53013 5.45099 5.45002 5.51967 5.34724C5.58834 5.24446 5.625 5.12362 5.625 5.00001C5.625 4.83425 5.55915 4.67527 5.44194 4.55806C5.32473 4.44085 5.16576 4.37501 5 4.37501Z"
//         fill="#999999"
//       />
//     </g>
//     <defs>
//       <clipPath id="clip0_1_854">
//         <rect width="10" height="10" fill="white" />
//       </clipPath>
//     </defs>
//   </svg>
// );

export const IconAlert = () => (
  <svg
    className="mr-2"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <g clipPath="url(#clip0_9_795)">
      <path
        d="M11 0C4.92545 0 0 4.92545 0 11C0 17.0746 4.92545 22 11 22C17.0746 22 22 17.0746 22 11C22 4.92545 17.0746 0 11 0ZM11 20.1339C5.9567 20.1339 1.86607 16.0433 1.86607 11C1.86607 5.9567 5.9567 1.86607 11 1.86607C16.0433 1.86607 20.1339 5.9567 20.1339 11C20.1339 16.0433 16.0433 20.1339 11 20.1339Z"
        fill="#FFC53D"
      />
      <path
        d="M9.82104 15.3214C9.82104 15.634 9.94522 15.9338 10.1662 16.1548C10.3873 16.3758 10.687 16.5 10.9996 16.5C11.3122 16.5 11.612 16.3758 11.833 16.1548C12.054 15.9338 12.1782 15.634 12.1782 15.3214C12.1782 15.0089 12.054 14.7091 11.833 14.4881C11.612 14.267 11.3122 14.1429 10.9996 14.1429C10.687 14.1429 10.3873 14.267 10.1662 14.4881C9.94522 14.7091 9.82104 15.0089 9.82104 15.3214V15.3214ZM10.4103 12.5714H11.5889C11.6969 12.5714 11.7853 12.483 11.7853 12.375V5.69643C11.7853 5.58839 11.6969 5.5 11.5889 5.5H10.4103C10.3023 5.5 10.2139 5.58839 10.2139 5.69643V12.375C10.2139 12.483 10.3023 12.5714 10.4103 12.5714Z"
        fill="#FFC53D"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_795">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconEnergyLabel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1_22)">
      <path
        d="M9.10416 13.4584C8.7611 13.4584 8.42807 13.4122 8.10507 13.3198C7.78155 13.2275 7.48124 13.0889 7.20416 12.9042L6.88749 13.2209C6.72916 13.3792 6.54444 13.4584 6.33332 13.4584C6.12221 13.4584 5.93749 13.3792 5.77916 13.2209C5.62082 13.0625 5.54166 12.8778 5.54166 12.6667C5.54166 12.4556 5.62082 12.2709 5.77916 12.1125L6.09582 11.7959C5.9111 11.5188 5.77256 11.2185 5.6802 10.8949C5.58784 10.5719 5.54166 10.2389 5.54166 9.89585C5.54166 8.86669 5.89791 8.01565 6.61041 7.34273C7.32291 6.66981 8.15416 6.33335 9.10416 6.33335H12.6667V9.89585C12.6667 10.8854 12.3204 11.7267 11.628 12.4197C10.935 13.1121 10.0937 13.4584 9.10416 13.4584ZM9.10416 11.875C9.65832 11.875 10.1267 11.6837 10.5094 11.3011C10.892 10.9184 11.0833 10.45 11.0833 9.89585V7.91669H9.10416C8.57638 7.91669 8.11457 8.10458 7.71874 8.48035C7.32291 8.85666 7.12499 9.32849 7.12499 9.89585C7.12499 10.0278 7.13819 10.1531 7.16457 10.2719C7.19096 10.3906 7.22395 10.5028 7.26353 10.6084L8.94582 8.94585C9.10416 8.78752 9.28888 8.70835 9.49999 8.70835C9.7111 8.70835 9.89582 8.78752 10.0542 8.94585C10.2125 9.10419 10.2917 9.28891 10.2917 9.50002C10.2917 9.71113 10.2125 9.89585 10.0542 10.0542L8.39166 11.7365C8.49721 11.7761 8.60937 11.809 8.72812 11.8354C8.84687 11.8618 8.97221 11.875 9.10416 11.875ZM9.49999 18.2084L6.76874 16.0709L3.34478 15.6552L2.92916 12.2313L0.791656 9.50002L2.92916 6.76877L3.34478 3.34481L6.76874 2.92919L9.49999 0.791687L12.2312 2.92919L15.6552 3.34481L16.0708 6.76877L18.2083 9.50002L16.0708 12.2313L15.6552 15.6552L12.2312 16.0709L9.49999 18.2084ZM9.49999 16.1896L11.5979 14.5667L14.25 14.2302L14.5667 11.5979L16.1896 9.50002L14.5667 7.4021L14.2302 4.76981L11.5979 4.43335L9.49999 2.81044L7.40207 4.43335L4.74999 4.76981L4.43332 7.4021L2.81041 9.50002L4.43332 11.5979L4.76978 14.25L7.40207 14.5667L9.49999 16.1896Z"
        fill="black"
        stroke="white"
        strokeWidth="0.4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_22">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconDelete = (props) => <AiOutlineDelete {...props} />;
export const IconUpload = (props) => <AiOutlineUpload {...props} />;
export const IconPlus = () => (
  <AiOutlinePlus className="text-base text-primary cursor-pointer" />
);

export const IconENG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.50002 0.649994H6.50002C3.57502 1.24999 1.25002 3.54999 0.650024 6.49999V9.49999C1.25002 12.45 3.57502 14.75 6.50002 15.35H9.50002C12.45 14.75 14.75 12.425 15.35 9.49999V6.49999C14.75 3.54999 12.425 1.24999 9.50002 0.649994Z"
      fill="#F4F4F4"
    />
    <path
      d="M15.2948 9.75C15.4315 9.17673 15.5004 8.58936 15.5 8C15.5 7.3975 15.429 6.8115 15.2948 6.25H9.75V0.705252C9.17673 0.568496 8.58936 0.499606 8 0.500002C7.3975 0.500002 6.8115 0.571002 6.25 0.705252V6.25H0.705252C0.568496 6.82328 0.499606 7.41064 0.500002 8C0.500002 8.6025 0.571002 9.1885 0.705252 9.75H6.25V15.2948C6.82328 15.4315 7.41064 15.5004 8 15.5C8.6025 15.5 9.1885 15.429 9.75 15.2948V9.75H15.2948Z"
      fill="#CE1124"
    />
  </svg>
);

export const IconFI = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15.275 6.25H7.75V0.5C6.475 0.55 5.275 0.9 4.25 1.5V6.25H0.7C0.575 6.8 0.5 7.4 0.5 8C0.5 8.6 0.575 9.2 0.7 9.75H4.25V14.5C5.275 15.1 6.475 15.45 7.75 15.5V9.75H15.3C15.425 9.2 15.5 8.6 15.5 8C15.5 7.4 15.425 6.8 15.275 6.25Z"
      fill="#428BC1"
    />
  </svg>
);

export const IconPDF = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      d="M3.19999 7.30001C3.09391 7.30001 2.99217 7.34215 2.91715 7.41716C2.84214 7.49218 2.79999 7.59392 2.79999 7.70001V9.30001C2.79999 9.40609 2.84214 9.50783 2.91715 9.58285C2.99217 9.65786 3.09391 9.70001 3.19999 9.70001C3.30608 9.70001 3.40782 9.65786 3.48284 9.58285C3.55785 9.50783 3.59999 9.40609 3.59999 9.30001V9.16721H3.86639C4.114 9.16721 4.35146 9.06884 4.52655 8.89376C4.70163 8.71868 4.79999 8.48121 4.79999 8.23361C4.79999 7.986 4.70163 7.74854 4.52655 7.57345C4.35146 7.39837 4.114 7.30001 3.86639 7.30001H3.19999ZM3.86639 8.36721H3.59999V8.10001H3.86639C3.90183 8.10001 3.93581 8.11408 3.96086 8.13914C3.98592 8.16419 3.99999 8.19817 3.99999 8.23361C3.99999 8.26904 3.98592 8.30302 3.96086 8.32808C3.93581 8.35313 3.90183 8.36721 3.86639 8.36721ZM7.59999 7.69921C7.60021 7.59326 7.64244 7.49172 7.71743 7.41688C7.79243 7.34204 7.89405 7.30001 7.99999 7.30001H8.79919C8.90528 7.30001 9.00702 7.34215 9.08204 7.41716C9.15705 7.49218 9.19919 7.59392 9.19919 7.70001C9.19919 7.80609 9.15705 7.90783 9.08204 7.98285C9.00702 8.05786 8.90528 8.10001 8.79919 8.10001H8.39919V8.36801H8.79919C8.90528 8.36801 9.00702 8.41015 9.08204 8.48516C9.15705 8.56018 9.19919 8.66192 9.19919 8.76801C9.19919 8.87409 9.15705 8.97583 9.08204 9.05085C9.00702 9.12586 8.90528 9.16801 8.79919 9.16801H8.39919L8.39999 9.29921C8.4001 9.35174 8.38986 9.40377 8.36985 9.45234C8.34985 9.50091 8.32047 9.54507 8.2834 9.58228C8.20854 9.65745 8.10688 9.69979 8.00079 9.70001C7.89471 9.70022 7.79288 9.65828 7.71772 9.58342C7.64255 9.50855 7.60021 9.40689 7.59999 9.30081V7.69921ZM5.59839 7.30001C5.49231 7.30001 5.39057 7.34215 5.31555 7.41716C5.24054 7.49218 5.19839 7.59392 5.19839 7.70001V9.30001C5.19839 9.40609 5.24054 9.50783 5.31555 9.58285C5.39057 9.65786 5.49231 9.70001 5.59839 9.70001H5.99999C6.31825 9.70001 6.62348 9.57358 6.84852 9.34853C7.07357 9.12349 7.19999 8.81827 7.19999 8.50001C7.19999 8.18175 7.07357 7.87652 6.84852 7.65148C6.62348 7.42643 6.31825 7.30001 5.99999 7.30001H5.59839ZM5.99839 8.90001V8.10001H5.99999C6.10608 8.10001 6.20782 8.14215 6.28284 8.21716C6.35785 8.29218 6.39999 8.39392 6.39999 8.50001C6.39999 8.60609 6.35785 8.70783 6.28284 8.78285C6.20782 8.85786 6.10608 8.90001 5.99999 8.90001H5.99839ZM1.19999 1.70001C1.19999 1.27566 1.36856 0.868693 1.66862 0.568635C1.96868 0.268577 2.37565 0.100006 2.79999 0.100006H6.46799C6.62566 0.10004 6.78178 0.131145 6.92742 0.191543C7.07306 0.251941 7.20537 0.340448 7.31679 0.452006L10.448 3.58321C10.6731 3.80803 10.7997 4.11305 10.8 4.43121V5.76561C11.0336 5.84858 11.2358 6.00188 11.3788 6.20444C11.5218 6.407 11.5985 6.64888 11.5984 6.89681V10.0992C11.5985 10.3471 11.5218 10.589 11.3788 10.7916C11.2358 10.9941 11.0336 11.1474 10.8 11.2304V11.3C10.8 11.7244 10.6314 12.1313 10.3314 12.4314C10.0313 12.7314 9.62434 12.9 9.19999 12.9H2.79999C2.37565 12.9 1.96868 12.7314 1.66862 12.4314C1.36856 12.1313 1.19999 11.7244 1.19999 11.3V11.2304C0.966189 11.1477 0.763736 10.9947 0.620478 10.7923C0.47722 10.5898 0.400195 10.348 0.399994 10.1V6.89761C0.399864 6.64935 0.476736 6.40716 0.620016 6.20441C0.763297 6.00167 0.965932 5.84836 1.19999 5.76561V1.70001ZM9.99999 4.90001H7.19999C6.88173 4.90001 6.57651 4.77358 6.35147 4.54853C6.12642 4.32349 5.99999 4.01827 5.99999 3.70001V0.900006H2.79999C2.58782 0.900006 2.38434 0.984292 2.23431 1.13432C2.08428 1.28435 1.99999 1.48783 1.99999 1.70001V5.69681H9.99999V4.90001ZM1.99999 11.2992C1.99989 11.4043 2.0205 11.5084 2.06066 11.6056C2.10082 11.7028 2.15973 11.791 2.23403 11.8654C2.30832 11.9398 2.39655 11.9988 2.49366 12.039C2.59078 12.0793 2.69487 12.1 2.79999 12.1H9.19999C9.30512 12.1 9.40921 12.0793 9.50633 12.039C9.60344 11.9988 9.69166 11.9398 9.76596 11.8654C9.84026 11.791 9.89917 11.7028 9.93933 11.6056C9.97948 11.5084 10.0001 11.4043 9.99999 11.2992H1.99999ZM6.79999 1.06561V3.70001C6.79999 3.80609 6.84214 3.90783 6.91715 3.98285C6.99217 4.05786 7.09391 4.10001 7.19999 4.10001H9.83439L6.79999 1.06561ZM1.59999 6.49681C1.49391 6.49681 1.39217 6.53895 1.31715 6.61396C1.24214 6.68898 1.19999 6.79072 1.19999 6.89681V10.0992C1.19999 10.2053 1.24214 10.307 1.31715 10.382C1.39217 10.4571 1.49391 10.4992 1.59999 10.4992H10.3976C10.5037 10.4992 10.6054 10.4571 10.6804 10.382C10.7555 10.307 10.7976 10.2053 10.7976 10.0992V6.89681C10.7976 6.79072 10.7555 6.68898 10.6804 6.61396C10.6054 6.53895 10.5037 6.49681 10.3976 6.49681H1.59999Z"
      fill="#777777"
    />
  </svg>
);

export const IconLostCart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    {...props}
  >
    <path
      d="M9.59937 18.1868C9.97712 19.3449 11.0918 20.1437 12.318 20.1437C15.501 20.1437 18.684 20.1437 21.867 20.1437C22.0838 20.1437 22.3067 20.1437 22.5111 20.1995C23.1489 20.3729 23.5143 21.0107 23.4214 21.76C23.3347 22.466 22.8702 22.9428 22.1891 22.949C20.4056 22.9614 18.6283 22.9552 16.8448 22.9614C15.3585 22.9614 13.8785 22.9428 12.3923 22.9614C10.2744 22.9985 8.72621 22.0325 7.63011 20.28C6.76313 18.899 6.34203 17.3508 6.03859 15.7655C5.32024 11.9756 4.5957 8.1857 3.85878 4.39579C3.834 4.27813 3.69777 4.1357 3.58011 4.09235C2.97322 3.86322 2.36015 3.65887 1.74708 3.44212C1.16497 3.23157 0.818179 2.68043 0.849142 2.04258C0.886298 1.37378 1.27644 0.859785 1.87093 0.729739C2.01336 0.698776 2.18056 0.698776 2.323 0.742125C3.27667 1.02699 4.23034 1.32423 5.184 1.61529C5.67323 1.76391 5.99524 2.08593 6.15625 2.56896C6.30488 3.00864 6.4535 3.44832 6.58355 3.888C6.63928 4.07377 6.71359 4.14809 6.91795 4.14809C13.0363 4.1357 19.1546 4.12951 25.273 4.12951C25.6136 4.12951 25.9542 4.12951 26.2948 4.16047C27.5147 4.24717 28.1092 4.97171 27.7501 6.27217C27.1308 8.5201 26.4434 10.7557 25.787 12.9974C25.4774 14.044 25.1863 15.0967 24.8643 16.1371C24.7528 16.4962 24.598 16.8554 24.4122 17.1774C24.0159 17.8586 23.4214 18.2054 22.604 18.2054C18.3929 18.193 14.1757 18.2054 9.96474 18.2054C9.85327 18.2054 9.7418 18.2054 9.59937 18.2054V18.1868ZM15.9902 12.9912C16.9315 12.9912 17.7179 13.2141 18.4425 13.7034C18.8079 13.9449 19.1361 14.2483 19.4829 14.5208C19.8296 14.7933 20.2755 14.7685 20.5728 14.4589C20.8638 14.1492 20.8824 13.6724 20.5728 13.369C19.0618 11.9199 17.3154 11.1148 15.1728 11.4988C13.8537 11.7341 12.7576 12.4091 11.804 13.3256C11.4757 13.6414 11.4819 14.1121 11.7792 14.4341C12.0641 14.7375 12.5223 14.7685 12.8691 14.496C12.993 14.4031 13.0982 14.2917 13.2159 14.1926C14.0643 13.4742 15.018 13.0098 15.9964 12.9912H15.9902ZM14.0024 9.41804C14.0147 8.78639 13.4884 8.24763 12.8505 8.24143C12.2189 8.24143 11.6863 8.76162 11.6863 9.39946C11.6863 10.0249 12.1879 10.5389 12.8196 10.5575C13.445 10.5761 13.99 10.0497 13.9962 9.41185L14.0024 9.41804ZM20.6347 9.41804C20.6347 8.774 20.1269 8.24763 19.489 8.24763C18.8698 8.24763 18.3434 8.75543 18.3372 9.38088C18.3248 10.0249 18.8326 10.5513 19.4705 10.5637C20.1021 10.5761 20.6347 10.0559 20.6409 9.41804H20.6347Z"
      fill="#727272"
    />
    <path
      d="M21.3405 24.4046C22.5357 24.4293 23.4646 25.4016 23.4336 26.5906C23.4027 27.7672 22.4428 28.7023 21.2724 28.6837C20.102 28.6651 19.1359 27.6743 19.1607 26.5039C19.1855 25.3211 20.1639 24.3798 21.3467 24.4046H21.3405Z"
      fill="#727272"
    />
    <path
      d="M12.7513 24.4046C13.9402 24.3984 14.9001 25.3397 14.9063 26.5287C14.9125 27.7053 13.9526 28.6837 12.776 28.6837C11.5994 28.6837 10.6334 27.7115 10.6334 26.5349C10.6334 25.3706 11.587 24.4108 12.7574 24.4046H12.7513Z"
      fill="#727272"
    />
  </svg>
);

export const IconWishlist = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 5.33325C13.0333 5.33325 12.4933 6.29325 12.7133 7.00659L10.3466 9.37992C10.1466 9.31992 9.85329 9.31992 9.65329 9.37992L7.95329 7.67992C8.17996 6.96659 7.63996 5.99992 6.66663 5.99992C5.69996 5.99992 5.15329 6.95992 5.37996 7.67992L2.33996 10.7133C1.62663 10.4933 0.666626 11.0333 0.666626 11.9999C0.666626 12.7333 1.26663 13.3333 1.99996 13.3333C2.96663 13.3333 3.50663 12.3733 3.28663 11.6599L6.31996 8.61992C6.51996 8.67992 6.81329 8.67992 7.01329 8.61992L8.71329 10.3199C8.48663 11.0333 9.02663 11.9999 9.99996 11.9999C10.9666 11.9999 11.5133 11.0399 11.2866 10.3199L13.66 7.95325C14.3733 8.17325 15.3333 7.63325 15.3333 6.66659C15.3333 5.93325 14.7333 5.33325 14 5.33325Z" fill="black"/>
    <path d="M9.99996 6L10.6266 4.62L12 4L10.6266 3.38L9.99996 2L9.38663 3.38L7.99996 4L9.38663 4.62L9.99996 6ZM2.33329 7.33333L2.66663 6L3.99996 5.66667L2.66663 5.33333L2.33329 4L1.99996 5.33333L0.666626 5.66667L1.99996 6L2.33329 7.33333Z" fill="black"/>
  </svg>
);

export const IconTag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M7.00001 2.1875L6.86308 2.31L1.87251 7.35569L1.57239 7.65669L1.87295 7.97169L6.0292 12.1279L6.3442 12.4285L6.64608 12.1279L11.6905 7.13737L11.8125 7V2.1875H7.00001ZM7.36926 3.0625H10.9375V6.63075L6.34376 11.1974L2.80264 7.65625L7.36926 3.0625ZM9.62501 3.9375C9.50898 3.9375 9.3977 3.98359 9.31565 4.06564C9.23361 4.14769 9.18751 4.25897 9.18751 4.375C9.18751 4.49103 9.23361 4.60231 9.31565 4.68436C9.3977 4.76641 9.50898 4.8125 9.62501 4.8125C9.74105 4.8125 9.85233 4.76641 9.93437 4.68436C10.0164 4.60231 10.0625 4.49103 10.0625 4.375C10.0625 4.25897 10.0164 4.14769 9.93437 4.06564C9.85233 3.98359 9.74105 3.9375 9.62501 3.9375Z"
      fill="black"
      fillOpacity="0.26"
    />
  </svg>
);

export const IconUserGear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    {...props}
  >
    <path
      d="M7 8.42858C8.57812 8.42858 9.85714 7.14956 9.85714 5.57144C9.85714 3.99331 8.57812 2.71429 7 2.71429C5.42188 2.71429 4.14286 3.99331 4.14286 5.57144C4.14286 7.14956 5.42188 8.42858 7 8.42858ZM9 9.14287H8.62723C8.1317 9.37054 7.58036 9.50001 7 9.50001C6.41964 9.50001 5.87054 9.37054 5.37277 9.14287H5C3.34375 9.14287 2 10.4866 2 12.1429V13.0714C2 13.663 2.47991 14.1429 3.07143 14.1429H10.9286C11.5201 14.1429 12 13.663 12 13.0714V12.1429C12 10.4866 10.6562 9.14287 9 9.14287Z"
      fill="black"
    />
    <g clipPath="url(#clip0_3_466)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 0.309387C11.3629 0.309387 11.2438 0.397096 11.0056 0.572721L10.6471 0.837095C10.6096 0.864804 10.5908 0.878554 10.5706 0.89022C10.5504 0.901887 10.529 0.911054 10.4863 0.929804L10.0781 1.10814C9.80688 1.22689 9.67125 1.28605 9.60271 1.4046C9.53438 1.52335 9.55063 1.67043 9.58375 1.9646L9.63333 2.4073C9.63854 2.45355 9.64104 2.47668 9.64104 2.50001C9.64104 2.52335 9.63854 2.54647 9.63333 2.59272L9.58375 3.03543C9.55083 3.3296 9.53438 3.47668 9.60271 3.59543C9.67146 3.71418 9.80688 3.77334 10.0781 3.89189L10.4865 4.07022C10.529 4.08897 10.5504 4.09814 10.5706 4.1098C10.5906 4.12147 10.6096 4.13522 10.6471 4.16293L11.0054 4.4273C11.244 4.60293 11.3631 4.69064 11.5 4.69064C11.6369 4.69064 11.7563 4.60293 11.9944 4.4273L12.3529 4.16293C12.3904 4.13522 12.4092 4.12147 12.4294 4.1098C12.4496 4.09814 12.471 4.08897 12.5138 4.07022L12.9219 3.89189C13.1931 3.77314 13.3288 3.71397 13.3973 3.59543C13.4656 3.47668 13.4494 3.3296 13.416 3.03543L13.3667 2.59272C13.3615 2.54647 13.3588 2.52335 13.3588 2.50001C13.3588 2.47668 13.3615 2.45355 13.3667 2.4073L13.4163 1.9646C13.4492 1.67043 13.4656 1.52335 13.3973 1.4046C13.3285 1.28585 13.1931 1.22668 12.9219 1.10814L12.5135 0.929804C12.4848 0.918137 12.4567 0.904923 12.4294 0.89022C12.4029 0.873904 12.3774 0.85617 12.3529 0.837095L11.9946 0.572721C11.7558 0.397096 11.6367 0.309387 11.5 0.309387ZM11.5 3.33335C11.721 3.33335 11.933 3.24555 12.0893 3.08927C12.2455 2.93299 12.3333 2.72103 12.3333 2.50001C12.3333 2.279 12.2455 2.06704 12.0893 1.91076C11.933 1.75448 11.721 1.66668 11.5 1.66668C11.279 1.66668 11.067 1.75448 10.9107 1.91076C10.7545 2.06704 10.6667 2.279 10.6667 2.50001C10.6667 2.72103 10.7545 2.93299 10.9107 3.08927C11.067 3.24555 11.279 3.33335 11.5 3.33335Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_466">
        <rect width="5" height="5" fill="white" transform="translate(9)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconPackageBox = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M2.33337 4.66666H11.6667M2.33337 4.66666V10.5C2.33337 10.8094 2.45629 11.1062 2.67508 11.325C2.89388 11.5437 3.19062 11.6667 3.50004 11.6667H10.5C10.8095 11.6667 11.1062 11.5437 11.325 11.325C11.5438 11.1062 11.6667 10.8094 11.6667 10.5V4.66666M2.33337 4.66666L4.66671 2.33333H9.33337L11.6667 4.66666M4.66671 6.99999H7.00004"
      stroke="black"
      strokeOpacity="0.46"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSandTimer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    {...props}
  >
    <path
      d="M6 7.33317H2V5.33317L3.33333 3.99984L2 2.6665V0.666504H6V2.6665L4.66667 3.99984L6 5.33317M2.66667 2.49984L4 3.83317L5.33333 2.49984V1.33317H2.66667M4 4.1665L2.66667 5.49984V6.6665H5.33333V5.49984M4.66667 5.99984H3.33333V5.73317L4 5.0665L4.66667 5.73317V5.99984Z"
      fill="white"
    />
  </svg>
);

export const IconBooksStacked = (props) => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 22.5C10.0625 22.5 9.47417 22.2554 8.985 21.7663C8.49583 21.2771 8.25083 20.6883 8.25 20V5C8.25 4.3125 8.495 3.72417 8.985 3.235C9.475 2.74583 10.0633 2.50083 10.75 2.5H25.75C26.4375 2.5 27.0263 2.745 27.5163 3.235C28.0063 3.725 28.2508 4.31333 28.25 5V20C28.25 20.6875 28.0054 21.2763 27.5163 21.7663C27.0271 22.2563 26.4383 22.5008 25.75 22.5H10.75ZM10.75 7.5H25.75V5H10.75V7.5ZM5.75 27.5C5.0625 27.5 4.47417 27.2554 3.985 26.7663C3.49583 26.2771 3.25083 25.6883 3.25 25V7.5H5.75V25H23.25V27.5H5.75Z"
      fill="#BFBFBF"
    />
  </svg>
);
export const IconRollbackPurple = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.06969 3.12718C6.06969 2.92534 6.2333 2.76172 6.43514 2.76172H8.62782C9.50012 2.76172 10.3367 3.10826 10.9535 3.7251C11.5703 4.34194 11.9168 5.17855 11.9168 6.0509C11.9168 6.92324 11.5703 7.75986 10.9535 8.3767C10.3367 8.99354 9.50012 9.34008 8.62782 9.34008H2.04977C1.84794 9.34008 1.68433 9.17645 1.68433 8.97461C1.68433 8.77277 1.84794 8.60915 2.04977 8.60915H8.62782C9.30627 8.60915 9.95694 8.33962 10.4367 7.85985C10.9164 7.38009 11.1859 6.72939 11.1859 6.0509C11.1859 5.37241 10.9164 4.72171 10.4367 4.24194C9.95694 3.76218 9.30627 3.49265 8.62782 3.49265H6.43514C6.2333 3.49265 6.06969 3.32902 6.06969 3.12718Z"
      fill="#9747FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.73497 3.12688C5.73497 2.74075 6.04798 2.42773 6.43409 2.42773H8.62677C9.58757 2.42773 10.509 2.80943 11.1884 3.48885C11.8678 4.16826 12.2495 5.08975 12.2495 6.0506C12.2495 7.01144 11.8678 7.93293 11.1884 8.61235C10.509 9.29177 9.58757 9.67346 8.62677 9.67346H2.04872C1.66261 9.67346 1.34961 9.36044 1.34961 8.97431C1.34961 8.58818 1.66261 8.27516 2.04872 8.27516H8.62677C9.21673 8.27516 9.78253 8.04079 10.1997 7.6236C10.6169 7.20642 10.8512 6.64059 10.8512 6.0506C10.8512 5.46061 10.6169 4.89478 10.1997 4.47759C9.78253 4.0604 9.21673 3.82603 8.62677 3.82603H6.43409C6.04798 3.82603 5.73497 3.51301 5.73497 3.12688ZM6.43409 3.0951C6.41654 3.0951 6.40231 3.10933 6.40231 3.12688C6.40231 3.14443 6.41654 3.15866 6.43409 3.15866H8.62677C9.39372 3.15866 10.1293 3.46335 10.6716 4.00569C11.2139 4.54803 11.5186 5.28361 11.5186 6.0506C11.5186 6.81758 11.2139 7.55316 10.6716 8.0955C10.1293 8.63785 9.39372 8.94253 8.62677 8.94253H2.04872C2.03117 8.94253 2.01695 8.95676 2.01695 8.97431C2.01695 8.99186 2.03117 9.00609 2.04872 9.00609H8.62677C9.41058 9.00609 10.1623 8.69471 10.7165 8.14045C11.2708 7.58618 11.5821 6.83444 11.5821 6.0506C11.5821 5.26675 11.2708 4.51501 10.7165 3.96075C10.1623 3.40648 9.41058 3.0951 8.62677 3.0951H6.43409Z"
      fill="#9747FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50086 6.52306C4.64358 6.66578 4.64358 6.89718 4.50086 7.0399L2.56659 8.97426L4.50086 10.9086C4.64358 11.0513 4.64358 11.2827 4.50086 11.4255C4.35815 11.5682 4.12676 11.5682 3.98404 11.4255L1.79136 9.23269C1.64865 9.08996 1.64865 8.85857 1.79136 8.71584L3.98404 6.52306C4.12676 6.38033 4.35815 6.38033 4.50086 6.52306Z"
      fill="#9747FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.74706 6.2873C4.02008 6.01426 4.46273 6.01426 4.73575 6.2873C5.00878 6.56033 5.00878 7.00301 4.73575 7.27604L3.03742 8.97445L4.73575 10.6729C5.00878 10.9459 5.00878 11.3886 4.73575 11.6616C4.46273 11.9346 4.02008 11.9346 3.74706 11.6616L1.55438 9.46883C1.28135 9.19579 1.28135 8.75311 1.55438 8.48008L3.74706 6.2873ZM4.26388 6.7592C4.25147 6.74678 4.23134 6.74678 4.21893 6.7592L2.02625 8.95198C2.01384 8.96439 2.01384 8.98451 2.02625 8.99692L1.79031 9.23287L2.02625 8.99692L4.21893 11.1897C4.23135 11.2021 4.25147 11.2021 4.26388 11.1897C4.27629 11.1773 4.27629 11.1572 4.26388 11.1448L2.32961 9.2104C2.26703 9.14783 2.23188 9.06295 2.23188 8.97445C2.23188 8.88595 2.26703 8.80108 2.32961 8.7385L4.26388 6.80414C4.27629 6.79173 4.27629 6.77161 4.26388 6.7592Z"
      fill="#9747FF"
    />
  </svg>
);

export const IconMarketing = (props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.75 2.09989C14.5781 1.98868 14.3815 1.92139 14.1775 1.90396C13.9735 1.88652 13.7683 1.91946 13.58 1.99989L7.41 4.42989C7.26393 4.48934 7.10771 4.51991 6.95 4.51989H3C2.66848 4.51989 2.35054 4.65159 2.11612 4.88601C1.8817 5.12043 1.75 5.43837 1.75 5.76989V5.86989H0.5V8.86989H1.75V8.99989C1.75783 9.32619 1.89298 9.63648 2.12656 9.86445C2.36013 10.0924 2.67361 10.22 3 10.2199L4.5 13.3999C4.60157 13.614 4.76148 13.7952 4.96136 13.9225C5.16124 14.0499 5.393 14.1183 5.63 14.1199H6.26C6.58979 14.1173 6.90516 13.9844 7.13743 13.7503C7.36969 13.5161 7.50001 13.1997 7.5 12.8699V10.3399L13.58 12.7699C13.7295 12.8294 13.889 12.8599 14.05 12.8599C14.2997 12.8559 14.5429 12.7794 14.75 12.6399C14.9145 12.5288 15.0501 12.3802 15.1458 12.2063C15.2414 12.0324 15.2943 11.8383 15.3 11.6399V3.12989C15.2991 2.92641 15.2485 2.72623 15.1527 2.54673C15.0568 2.36723 14.9186 2.21384 14.75 2.09989ZM6.25 5.76989V8.99989H3V5.76989H6.25ZM6.25 12.8699H5.62L4.39 10.2199H6.25V12.8699ZM7.87 9.14989C7.75127 9.08922 7.62747 9.03903 7.5 8.99989V5.69989C7.62624 5.67385 7.75003 5.63705 7.87 5.58989L14.05 3.12989V11.6099L7.87 9.14989ZM15.33 6.11989V8.61989C15.6615 8.61989 15.9795 8.4882 16.2139 8.25378C16.4483 8.01936 16.58 7.70142 16.58 7.36989C16.58 7.03837 16.4483 6.72043 16.2139 6.48601C15.9795 6.25159 15.6615 6.11989 15.33 6.11989Z"
      fill="#212121"
    />
  </svg>
);
export const IconImageModal = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.75 2.09999C14.5781 1.98877 14.3815 1.92148 14.1775 1.90405C13.9735 1.88661 13.7683 1.91956 13.58 1.99999L7.41 4.42999C7.26393 4.48944 7.10771 4.52 6.95 4.51999H3C2.66848 4.51999 2.35054 4.65168 2.11612 4.8861C1.8817 5.12052 1.75 5.43847 1.75 5.76999V5.86999H0.5V8.86999H1.75V8.99999C1.75783 9.32628 1.89298 9.63657 2.12656 9.86454C2.36013 10.0925 2.67361 10.2201 3 10.22L4.5 13.4C4.60157 13.6141 4.76148 13.7953 4.96136 13.9226C5.16124 14.05 5.393 14.1184 5.63 14.12H6.26C6.58979 14.1173 6.90516 13.9845 7.13743 13.7504C7.36969 13.5162 7.50001 13.1998 7.5 12.87V10.34L13.58 12.77C13.7295 12.8295 13.889 12.86 14.05 12.86C14.2997 12.856 14.5429 12.7795 14.75 12.64C14.9145 12.5289 15.0501 12.3803 15.1458 12.2064C15.2414 12.0325 15.2943 11.8384 15.3 11.64V3.12999C15.2991 2.9265 15.2485 2.72632 15.1527 2.54682C15.0568 2.36732 14.9186 2.21394 14.75 2.09999ZM6.25 5.76999V8.99999H3V5.76999H6.25ZM6.25 12.87H5.62L4.39 10.22H6.25V12.87ZM7.87 9.14999C7.75127 9.08931 7.62747 9.03912 7.5 8.99999V5.69999C7.62624 5.67394 7.75003 5.63714 7.87 5.58999L14.05 3.12999V11.61L7.87 9.14999ZM15.33 6.11999V8.61999C15.6615 8.61999 15.9795 8.48829 16.2139 8.25387C16.4483 8.01945 16.58 7.70151 16.58 7.36999C16.58 7.03847 16.4483 6.72052 16.2139 6.4861C15.9795 6.25168 15.6615 6.11999 15.33 6.11999Z"
      fill="#212121"
    />
  </svg>
);

export const IconBanners = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.37129 29.75C8.71962 29.75 8.17562 29.5318 7.73929 29.0955C7.30296 28.6592 7.08432 28.1147 7.08337 27.4621V6.53792C7.08337 5.88625 7.30201 5.34225 7.73929 4.90592C8.17657 4.46958 8.72057 4.25094 9.37129 4.25H24.6288C25.2805 4.25 25.8245 4.46864 26.2608 4.90592C26.6971 5.34319 26.9158 5.88719 26.9167 6.53792V27.4621C26.9167 28.1138 26.6985 28.6578 26.2622 29.0941C25.8259 29.5304 25.2814 29.7491 24.6288 29.75H9.37129ZM9.37129 28.3333H24.6288C24.846 28.3333 25.0458 28.2427 25.228 28.0613C25.4103 27.88 25.501 27.6803 25.5 27.4621V6.53792C25.5 6.32069 25.4094 6.12094 25.228 5.93867C25.0467 5.75639 24.847 5.66572 24.6288 5.66667H9.37129C9.15407 5.66667 8.95432 5.75733 8.77204 5.93867C8.58976 6.12 8.4991 6.31975 8.50004 6.53792V27.4621C8.50004 27.6793 8.59071 27.8791 8.77204 28.0613C8.95337 28.2436 9.15312 28.3343 9.37129 28.3333ZM10.9523 24.7917H23.266L19.3588 19.6152L15.8837 23.9743L13.6326 21.3038L10.9523 24.7917Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const IconMobile = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.75 5H11.25M13.5717 2.5H6.42833C5.64 2.5 5 3.17167 5 4V16C5 16.8283 5.64 17.5 6.42833 17.5H13.5717C14.3608 17.5 15 16.8283 15 16V4C15 3.17167 14.3608 2.5 13.5717 2.5Z"
      stroke="#212121"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDraggableBig = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.121338 9H5.62134V12.085L4.32634 10.795L3.62134 11.5L6.12134 14L8.62134 11.5L7.91634 10.795L6.62134 12.085V9H12.1213V8H0.121338V9ZM3.62134 2.5L4.32634 3.205L5.62134 1.915V5H0.121338V6H12.1213V5H6.62134V1.915L7.91634 3.205L8.62134 2.5L6.12134 0L3.62134 2.5Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const IconFeaturedCategoryProducts = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_97_17248)">
      <path
        d="M22.6152 16.9996C21.7174 16.9996 20.8727 16.5215 20.4159 15.7565L16.9999 10.0934L13.5893 15.7565C13.1271 16.5268 12.2824 17.0049 11.3846 17.0049C11.1456 17.0049 10.9065 16.9731 10.6781 16.904L3.39993 14.8215V24.2777C3.39993 25.0587 3.93118 25.7387 4.68555 25.9246L16.1712 28.7987C16.7131 28.9315 17.2815 28.9315 17.8181 28.7987L29.3143 25.9246C30.0687 25.7334 30.5999 25.0534 30.5999 24.2777V14.8215L23.3218 16.8987C23.0934 16.9677 22.8543 16.9996 22.6152 16.9996ZM33.9096 11.039L31.1737 5.57774C31.009 5.24837 30.6531 5.05712 30.2865 5.10493L16.9999 6.79962L21.8715 14.8799C22.0734 15.2146 22.4771 15.374 22.8543 15.2677L33.3677 12.2662C33.8937 12.1121 34.1487 11.5277 33.9096 11.039ZM2.82618 5.57774L0.0902417 11.039C-0.154133 11.5277 0.106179 12.1121 0.626804 12.2609L11.1402 15.2624C11.5174 15.3687 11.9212 15.2093 12.1231 14.8746L16.9999 6.79962L3.70805 5.10493C3.34149 5.06243 2.99087 5.24837 2.82618 5.57774Z"
        fill="#BFBFBF"
      />
    </g>
    <defs>
      <clipPath id="clip0_97_17248">
        <rect width="34" height="34" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconPromotionPopups = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_108_50393)">
      <path
        d="M0 2V23H24V2H0ZM22.5 21.5H1.5V6.5H22.5V21.5ZM22.5 5H21V3.5H22.5V5Z"
        fill="#BFBFBF"
      />
    </g>
    <defs>
      <clipPath id="clip0_108_50393">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconOpenVector = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16666 2.66667H4.49999C4.14637 2.66667 3.80723 2.80714 3.55718 3.05719C3.30713 3.30724 3.16666 3.64638 3.16666 4V12C3.16666 12.3536 3.30713 12.6928 3.55718 12.9428C3.80723 13.1929 4.14637 13.3333 4.49999 13.3333H12.5C12.8536 13.3333 13.1928 13.1929 13.4428 12.9428C13.6928 12.6928 13.8333 12.3536 13.8333 12V9.33333M8.49999 8L13.8333 2.66667M13.8333 2.66667V6M13.8333 2.66667H10.5"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.16666 2.66667H4.49999C4.14637 2.66667 3.80723 2.80714 3.55718 3.05719C3.30713 3.30724 3.16666 3.64638 3.16666 4V12C3.16666 12.3536 3.30713 12.6928 3.55718 12.9428C3.80723 13.1929 4.14637 13.3333 4.49999 13.3333H12.5C12.8536 13.3333 13.1928 13.1929 13.4428 12.9428C13.6928 12.6928 13.8333 12.3536 13.8333 12V9.33333M8.49999 8L13.8333 2.66667M13.8333 2.66667V6M13.8333 2.66667H10.5"
      stroke="#C4C4C4"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconRollback = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4417 11.6667C17.2409 13.0551 16.5466 14.3247 15.486 15.243C14.4255 16.1613 13.0695 16.6667 11.6667 16.6667H4.58332V15H11.6667C12.7717 15 13.8315 14.561 14.6129 13.7796C15.3943 12.9982 15.8333 11.9384 15.8333 10.8333C15.8333 9.72826 15.3943 8.66845 14.6129 7.88705C13.8315 7.10565 12.7717 6.66666 11.6667 6.66666H5.76166L7.84499 8.75L6.66666 9.92833L2.57166 5.83333L6.66666 1.73833L7.84499 2.91666L5.76166 5H11.6667C13.2138 5 14.6975 5.61458 15.7914 6.70854C16.8854 7.8025 17.5 9.28623 17.5 10.8333V11.6667H17.4417Z"
      fill="white"
    />
  </svg>
);

export const IconExcelWhite = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66705 4.99998V1.99998C2.66705 1.82317 2.73729 1.6536 2.86232 1.52858C2.98734 1.40355 3.15691 1.33332 3.33372 1.33332H12.6671C12.8439 1.33332 13.0134 1.40355 13.1385 1.52858C13.2635 1.6536 13.3337 1.82317 13.3337 1.99998V14C13.3337 14.1768 13.2635 14.3464 13.1385 14.4714C13.0134 14.5964 12.8439 14.6666 12.6671 14.6666H3.33372C3.15691 14.6666 2.98734 14.5964 2.86232 14.4714C2.73729 14.3464 2.66705 14.1768 2.66705 14V11"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3336 5.00005H11.3336M9.33356 7.66671H11.3336M9.33356 10.3334H11.3336"
      stroke="white"
      strokeLinecap="round"
    />
    <path
      d="M3.33356 7.00005L5.33356 9.00005M5.33356 7.00005L3.33356 9.00005M1.33356 5.00005H7.33356V11H1.33356V5.00005Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TechnoramaIcon = (props) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 160 160"
    style={{ enableBackground: "new 0 0 160 160" }}
    xmlSpace="preserve"
    width="16"
    height="16"
    {...props}
  >
    <style type="text/css">
      {`
        .st0{fillRule:evenodd;clipRule:evenodd;}
        .st1{fillRule:evenodd;clipRule:evenodd;fill:#FF0400;}
        .st2{fillRule:evenodd;clipRule:evenodd;fill:#F57F29;}
      `}
    </style>
    <g>
      <path
        className="st0"
        d="M79.9,117.1c-7.4,0-14.7-2.2-20.8-6.3c-6.2-4.1-11-10-13.8-16.8c-2.8-6.8-3.6-14.4-2.1-21.6
        c1.4-7.3,5-13.9,10.2-19.2c0.6-0.7,1.4-1.2,2.3-1.5c0.8-0.4,1.8-0.5,2.7-0.5c0.9,0,1.8,0.2,2.7,0.5c0.8,0.3,1.6,0.9,2.3,1.5
        c0.6,0.6,1.2,1.4,1.5,2.3c0.4,0.8,0.5,1.8,0.5,2.7c0,0.9-0.2,1.8-0.5,2.7c-0.4,0.8-0.9,1.6-1.5,2.3c-3.3,3.3-5.5,7.5-6.4,12
        c-0.9,4.6-0.4,9.3,1.3,13.6c1.8,4.3,4.8,8,8.7,10.6c3.9,2.6,8.4,4,13.1,4s9.2-1.4,13.1-4c3.9-2.6,6.9-6.3,8.7-10.6
        c1.8-4.3,2.2-9,1.3-13.6c-0.9-4.6-3.1-8.8-6.4-12c-0.6-0.6-1.2-1.4-1.5-2.3c-0.4-0.8-0.5-1.8-0.5-2.7c0-0.9,0.2-1.8,0.5-2.7
        s0.9-1.6,1.5-2.3c0.6-0.6,1.4-1.2,2.3-1.5c0.8-0.3,1.8-0.5,2.7-0.5c0.9,0,1.8,0.2,2.7,0.5c0.8,0.3,1.6,0.9,2.3,1.5
        c5.2,5.2,8.8,11.9,10.2,19.2c1.4,7.3,0.7,14.8-2.1,21.6c-2.8,6.8-7.6,12.7-13.8,16.8C94.5,114.9,87.3,117.1,79.9,117.1z"
      />
      <path
        className="st0"
        d="M79.8,86.6c-0.9,0-1.8-0.2-2.7-0.5c-0.8-0.3-1.6-0.9-2.3-1.5c-0.6-0.6-1.2-1.4-1.5-2.3s-0.5-1.7-0.5-2.7V49.3
        c0-0.9,0.2-1.8,0.5-2.7c0.3-0.8,0.9-1.6,1.5-2.3c0.6-0.6,1.4-1.2,2.3-1.5c0.8-0.3,1.8-0.5,2.7-0.5c0.9,0,1.8,0.2,2.7,0.5
        c0.8,0.3,1.6,0.9,2.3,1.5c0.6,0.6,1.2,1.4,1.5,2.3c0.4,0.8,0.5,1.8,0.5,2.7v30.4c0,0.9-0.2,1.8-0.5,2.7c-0.3,0.8-0.9,1.6-1.5,2.3
        c-0.6,0.6-1.4,1.2-2.3,1.5C81.7,86.4,80.8,86.6,79.8,86.6z"
      />
      <path
        className="st1"
        d="M80.1,18.5c8.4,0,16.6,1.7,24.3,5s14.6,8.2,20.3,14.3l13.6-12.5c-7.5-8-16.5-14.4-26.5-18.7
        C101.8,2.2,90.9,0,80,0C69.1,0,58.2,2.2,48.2,6.6c-10,4.4-19.1,10.7-26.5,18.7l13.7,12.6c5.7-6.1,12.7-11,20.4-14.3
        C63.4,20.2,71.7,18.5,80.1,18.5z"
      />
      <path
        className="st2"
        d="M79.9,141.5c-8.4,0-16.6-1.7-24.3-5c-7.7-3.3-14.6-8.2-20.3-14.3l-13.6,12.5c7.5,8,16.5,14.4,26.5,18.7
        c10,4.4,20.9,6.6,31.8,6.6s21.8-2.2,31.8-6.6s19.1-10.7,26.5-18.7l-13.7-12.6c-5.7,6.1-12.7,11-20.4,14.3
        C96.6,139.8,88.3,141.5,79.9,141.5"
      />
    </g>
  </svg>
);

export const IconIMUMRulesImageModal = ({ className, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  let fillColor = "#D9D9D9";
  if (isActive) {
    fillColor = "#8e8e8e";
  } else if (isHovered) {
    fillColor = "#ababab";
  }

  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onMouseDown={() => setIsActive(true)}
      onMouseUp={() => setIsActive(false)}
      {...props}
    >
      <path
        d="M4.16664 17.8301C3.7083 17.8301 3.31608 17.667 2.98997 17.3409C2.66386 17.0148 2.50053 16.6223 2.49997 16.1634V4.49674C2.49997 4.03841 2.6633 3.64619 2.98997 3.32008C3.31664 2.99397 3.70886 2.83063 4.16664 2.83008H15.8333C16.2916 2.83008 16.6841 2.99341 17.0108 3.32008C17.3375 3.64674 17.5005 4.03897 17.5 4.49674V16.1634C17.5 16.6217 17.3369 17.0142 17.0108 17.3409C16.6847 17.6676 16.2922 17.8306 15.8333 17.8301H4.16664ZM4.16664 16.1634H15.8333V4.49674H4.16664V16.1634ZM4.99997 14.4967H15L11.875 10.3301L9.37497 13.6634L7.49997 11.1634L4.99997 14.4967Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const IconCloseBold = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.77295 9.06708C9.87862 9.17275 9.93799 9.31607 9.93799 9.46552C9.93799 9.61496 9.87862 9.75828 9.77295 9.86395C9.66728 9.96963 9.52395 10.029 9.37451 10.029C9.22507 10.029 9.08175 9.96963 8.97607 9.86395L5.99998 6.88692L3.02295 9.86302C2.91728 9.96869 2.77395 10.0281 2.62451 10.0281C2.47507 10.0281 2.33175 9.96869 2.22607 9.86302C2.1204 9.75734 2.06104 9.61402 2.06104 9.46458C2.06104 9.31514 2.1204 9.17181 2.22607 9.06614L5.2031 6.09005L2.22701 3.11302C2.12134 3.00734 2.06197 2.86402 2.06197 2.71458C2.06197 2.56514 2.12134 2.42181 2.22701 2.31614C2.33268 2.21047 2.47601 2.1511 2.62545 2.1511C2.77489 2.1511 2.91821 2.21047 3.02389 2.31614L5.99998 5.29317L8.97701 2.31567C9.08268 2.21 9.226 2.15063 9.37545 2.15063C9.52489 2.15063 9.66821 2.21 9.77389 2.31567C9.87956 2.42135 9.93892 2.56467 9.93892 2.71411C9.93892 2.86355 9.87956 3.00688 9.77389 3.11255L6.79685 6.09005L9.77295 9.06708Z"
      fill="black"
    />
  </svg>
);

export const IconEditBold = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_223_7353)">
      <path
        d="M8.3875 2.39995L10.2667 4.27912C10.3458 4.35828 10.3458 4.48745 10.2667 4.56662L5.71667 9.11662L3.78333 9.3312C3.525 9.36037 3.30625 9.14162 3.33542 8.88328L3.55 6.94995L8.1 2.39995C8.17917 2.32078 8.30833 2.32078 8.3875 2.39995ZM11.7625 1.92287L10.7458 0.906201C10.4292 0.589534 9.91458 0.589534 9.59583 0.906201L8.85833 1.6437C8.77917 1.72287 8.77917 1.85203 8.85833 1.9312L10.7375 3.81037C10.8167 3.88953 10.9458 3.88953 11.025 3.81037L11.7625 3.07287C12.0792 2.75412 12.0792 2.23953 11.7625 1.92287ZM8 7.87912V9.99995H1.33333V3.33328H6.12083C6.1875 3.33328 6.25 3.3062 6.29792 3.26037L7.13125 2.42703C7.28958 2.2687 7.17708 1.99995 6.95417 1.99995H1C0.447917 1.99995 0 2.44787 0 2.99995V10.3333C0 10.8854 0.447917 11.3333 1 11.3333H8.33333C8.88542 11.3333 9.33333 10.8854 9.33333 10.3333V7.04578C9.33333 6.82287 9.06458 6.71245 8.90625 6.8687L8.07292 7.70203C8.02708 7.74995 8 7.81245 8 7.87912Z"
        fill="#BFBFBF"
      />
    </g>
    <defs>
      <clipPath id="clip0_223_7353">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const IconTimerStatistics = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00001 0.833338C7.30126 0.833338 9.16668 2.69875 9.16668 5.00001C9.16668 7.30126 7.30126 9.16667 5.00001 9.16667C2.69876 9.16667 0.833344 7.30126 0.833344 5.00001C0.833344 2.69875 2.69876 0.833338 5.00001 0.833338ZM5.00001 1.66667C4.11596 1.66667 3.26811 2.01786 2.64299 2.64298C2.01787 3.2681 1.66668 4.11595 1.66668 5.00001C1.66668 5.88406 2.01787 6.73191 2.64299 7.35703C3.26811 7.98215 4.11596 8.33334 5.00001 8.33334C5.88407 8.33334 6.73191 7.98215 7.35703 7.35703C7.98216 6.73191 8.33334 5.88406 8.33334 5.00001C8.33334 4.11595 7.98216 3.2681 7.35703 2.64298C6.73191 2.01786 5.88407 1.66667 5.00001 1.66667ZM5.00001 2.5C5.10207 2.50002 5.20057 2.53749 5.27683 2.6053C5.3531 2.67312 5.40182 2.76657 5.41376 2.86792L5.41668 2.91667V4.82751L6.54459 5.95542C6.61932 6.0304 6.66271 6.13102 6.66594 6.23683C6.66917 6.34264 6.63201 6.44572 6.56199 6.52512C6.49198 6.60452 6.39436 6.6543 6.28898 6.66434C6.1836 6.67438 6.07834 6.64393 5.99459 6.57917L5.95543 6.54459L4.70543 5.29459C4.64067 5.22977 4.59908 5.14542 4.58709 5.05459L4.58334 5.00001V2.91667C4.58334 2.80616 4.62724 2.70018 4.70538 2.62204C4.78352 2.5439 4.8895 2.5 5.00001 2.5Z"
        fill="#212121"
      />
    </svg>
  );
};

export const IconImumClock = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="16" height="16" rx="8" fill="#F0F0F0" />
      <path
        d="M8.5 4C10.9853 4 13 6.01465 13 8.5C13 10.9853 10.9853 13 8.5 13C6.01465 13 4 10.9853 4 8.5C4 6.01465 6.01465 4 8.5 4ZM8.5 4.9C7.54522 4.9 6.62955 5.27928 5.95442 5.95442C5.27928 6.62955 4.9 7.54522 4.9 8.5C4.9 9.45478 5.27928 10.3705 5.95442 11.0456C6.62955 11.7207 7.54522 12.1 8.5 12.1C9.45478 12.1 10.3705 11.7207 11.0456 11.0456C11.7207 10.3705 12.1 9.45478 12.1 8.5C12.1 7.54522 11.7207 6.62955 11.0456 5.95442C10.3705 5.27928 9.45478 4.9 8.5 4.9ZM8.5 5.8C8.61022 5.80001 8.7166 5.84048 8.79897 5.91372C8.88133 5.98696 8.93395 6.08789 8.94685 6.19735L8.95 6.25V8.3137L10.1681 9.53185C10.2489 9.61283 10.2957 9.7215 10.2992 9.83577C10.3027 9.95005 10.2626 10.0614 10.1869 10.1471C10.1113 10.2329 10.0059 10.2866 9.89209 10.2975C9.77827 10.3083 9.6646 10.2754 9.57415 10.2055L9.53185 10.1681L8.18185 8.81815C8.11191 8.74815 8.06699 8.65705 8.05405 8.55895L8.05 8.5V6.25C8.05 6.13065 8.09741 6.01619 8.1818 5.9318C8.26619 5.84741 8.38065 5.8 8.5 5.8Z"
        fill="#5F5F5F"
      />
    </svg>
  );
};

export const IconTrRequestDispatch = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.359985"
        y="0.559998"
        width="16"
        height="16"
        rx="8"
        fill="#212121"
      />
      <path
        d="M6.30917 12.56C6.2425 12.56 6.20917 12.5267 6.20917 12.46V5.66C6.20917 5.59333 6.2425 5.56 6.30917 5.56H8.66917C9.32917 5.56 9.8525 5.73333 10.2392 6.08C10.6325 6.42666 10.8292 6.89666 10.8292 7.49V10.63C10.8292 11.2233 10.6325 11.6933 10.2392 12.04C9.8525 12.3867 9.32917 12.56 8.66917 12.56H6.30917ZM6.91917 11.9C6.91917 11.9267 6.9325 11.94 6.95917 11.94H8.69917C9.1325 11.94 9.47583 11.8133 9.72917 11.56C9.98917 11.3067 10.1192 10.9667 10.1192 10.54V7.59C10.1192 7.15666 9.9925 6.81333 9.73917 6.56C9.48583 6.30666 9.13917 6.18 8.69917 6.18H6.95917C6.9325 6.18 6.91917 6.19333 6.91917 6.22V11.9Z"
        fill="white"
      />
    </svg>
  );
};

export const IconTrRequestWithdrawal = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.359985"
        y="0.559998"
        width="16"
        height="16"
        rx="8"
        fill="#E8E8E8"
      />
      <path
        d="M6.28034 12.56C6.227 12.56 6.19034 12.5333 6.17034 12.48L4.25034 5.67L4.24034 5.64C4.24034 5.58666 4.27367 5.56 4.34034 5.56H4.87034C4.93034 5.56 4.967 5.58666 4.98034 5.64L6.50034 11.12C6.507 11.1333 6.51367 11.14 6.52034 11.14C6.53367 11.14 6.54367 11.1333 6.55034 11.12L7.96034 5.65C7.97367 5.59 8.01034 5.56 8.07034 5.56H8.61034C8.67034 5.56 8.707 5.59 8.72034 5.65L10.1903 11.12C10.197 11.1333 10.2037 11.14 10.2103 11.14C10.2237 11.14 10.2337 11.1333 10.2403 11.12L11.7603 5.64C11.7737 5.58666 11.8103 5.56 11.8703 5.56H12.3803C12.4137 5.56 12.437 5.57 12.4503 5.59C12.4703 5.61 12.477 5.63666 12.4703 5.67L10.5803 12.48C10.567 12.5333 10.5303 12.56 10.4703 12.56H9.94034C9.88034 12.56 9.84367 12.53 9.83034 12.47L8.37034 6.87C8.36367 6.85666 8.35367 6.85 8.34034 6.85C8.33367 6.85 8.327 6.85666 8.32034 6.87L6.89034 12.47C6.88367 12.53 6.847 12.56 6.78034 12.56H6.28034Z"
        fill="#212121"
      />
    </svg>
  );
};

export const IconCloseCircle = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_187_8)">
        <path
          d="M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM9.26133 9.32695L8.35898 9.32285L7 7.70273L5.64238 9.32148L4.73867 9.32559C4.67852 9.32559 4.6293 9.27773 4.6293 9.21621C4.6293 9.19023 4.63887 9.16563 4.65527 9.14512L6.43398 7.02598L4.65527 4.9082C4.63875 4.88817 4.62959 4.86308 4.6293 4.83711C4.6293 4.77695 4.67852 4.72773 4.73867 4.72773L5.64238 4.73184L7 6.35195L8.35762 4.7332L9.25996 4.7291C9.32012 4.7291 9.36934 4.77695 9.36934 4.83848C9.36934 4.86445 9.35977 4.88906 9.34336 4.90957L7.56738 7.02734L9.34473 9.14648C9.36113 9.16699 9.3707 9.1916 9.3707 9.21758C9.3707 9.27773 9.32148 9.32695 9.26133 9.32695Z"
          fill="#FF4D4F"
        />
      </g>
      <defs>
        <clipPath id="clip0_187_8">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IconXmlFeedGeneration = (props) => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.52083 6.52831L6.5 1.65331L9.47917 6.52831H3.52083ZM9.47917 12.4866C8.80208 12.4866 8.22665 12.2498 7.75287 11.776C7.2791 11.3022 7.04203 10.7266 7.04167 10.0491C7.04131 9.3717 7.27838 8.79627 7.75287 8.32285C8.22738 7.84944 8.80281 7.61237 9.47917 7.61164C10.1555 7.61092 10.7311 7.84799 11.206 8.32285C11.6809 8.79771 11.9178 9.37314 11.9167 10.0491C11.9156 10.7251 11.6787 11.3008 11.206 11.776C10.7333 12.2512 10.1577 12.4881 9.47917 12.4866ZM1.625 12.2158V7.88248H5.95833V12.2158H1.625Z" fill="black" />
    </svg>
  );
};
export const IconXmlFeedGenerationBanner = (props) => {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.22917 10.9217L11.5 2.29666L16.7708 10.9217H6.22917ZM16.7708 21.4633C15.5729 21.4633 14.5548 21.0442 13.7166 20.206C12.8784 19.3678 12.459 18.3494 12.4583 17.1508C12.4577 15.9523 12.8771 14.9342 13.7166 14.0966C14.5561 13.259 15.5742 12.8396 16.7708 12.8383C17.9675 12.8371 18.9859 13.2565 19.826 14.0966C20.6661 14.9368 21.0852 15.9548 21.0833 17.1508C21.0814 18.3468 20.6623 19.3652 19.826 20.206C18.9897 21.0468 17.9713 21.4659 16.7708 21.4633ZM2.875 20.9842V13.3175H10.5417V20.9842H2.875Z" fill="#CACACA" />
    </svg>

  );
};

export const IconPixelArt = () => {
  return (
    <svg
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 4.5H32V31.5H5V4.5ZM8 7.5V28.5H29V7.5H8ZM11 10.5H17V16.5H11V10.5ZM20 10.5H26V16.5H20V10.5ZM11 19.5H17V25.5H11V19.5ZM20 19.5H26V25.5H20V19.5Z"
        fill="#BFBFBF"
      />
    </svg>
  );
};

export const IconOrdersAlertsSettings = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73978 15.1666C5.41446 15.1647 5.09859 15.057 4.83978 14.8599L3.45978 13.8333C3.14132 13.585 2.93002 13.2241 2.86927 12.8249C2.80851 12.4257 2.90293 12.0184 3.13311 11.6866C3.25491 11.5068 3.33231 11.3006 3.35896 11.085C3.38562 10.8695 3.36076 10.6507 3.28645 10.4466L3.24645 10.3399C3.1947 10.1552 3.10012 9.98527 2.97038 9.84396C2.84065 9.70264 2.67942 9.5939 2.49978 9.52659H2.39311C2.00369 9.39564 1.68165 9.11636 1.49692 8.74939C1.31218 8.38242 1.27967 7.95739 1.40645 7.56659L1.95311 5.83325C2.00344 5.63243 2.09608 5.44467 2.22486 5.28256C2.35363 5.12044 2.51555 4.98771 2.69978 4.89325C2.87135 4.80485 3.05907 4.75218 3.25158 4.73843C3.44409 4.72468 3.63739 4.75014 3.81978 4.81325C4.01837 4.88009 4.23028 4.89741 4.43708 4.86372C4.64389 4.83002 4.83934 4.74633 5.00645 4.61992L5.09311 4.55325C5.24438 4.43256 5.36663 4.27945 5.45085 4.10523C5.53508 3.931 5.57914 3.7401 5.57978 3.54659V3.38659C5.57799 2.97867 5.73741 2.58657 6.02335 2.29564C6.30928 2.00471 6.69856 1.83852 7.10645 1.83325H8.80645C9.0049 1.83379 9.20129 1.87352 9.38434 1.95017C9.56739 2.02683 9.7335 2.13889 9.87311 2.27992C10.1666 2.57845 10.3297 2.98127 10.3264 3.39992V3.58659C10.3231 3.77042 10.3629 3.95248 10.4428 4.11807C10.5227 4.28367 10.6404 4.42817 10.7864 4.53992L10.8598 4.59325C11.0094 4.70545 11.1839 4.77981 11.3685 4.80999C11.5531 4.84018 11.7422 4.82528 11.9198 4.76659L12.1464 4.69325C12.3385 4.62959 12.5414 4.60526 12.743 4.62172C12.9447 4.63817 13.141 4.69507 13.3201 4.78901C13.4993 4.88296 13.6578 5.01203 13.786 5.16853C13.9142 5.32503 14.0096 5.50576 14.0664 5.69992L14.5931 7.37992C14.715 7.76818 14.6817 8.18856 14.5002 8.55278C14.3187 8.91701 14.0031 9.19674 13.6198 9.33325L13.4864 9.37992C13.2903 9.44414 13.113 9.55553 12.97 9.70432C12.827 9.85312 12.7228 10.0347 12.6664 10.2333C12.6134 10.4178 12.6008 10.6116 12.6296 10.8015C12.6583 10.9913 12.7278 11.1727 12.8331 11.3333L13.0064 11.5866C13.2363 11.9202 13.3298 12.3291 13.2679 12.7295C13.2059 13.1299 12.9931 13.4914 12.6731 13.7399L11.3331 14.7733C11.1712 14.8971 10.9857 14.9864 10.788 15.0358C10.5903 15.0852 10.3845 15.0937 10.1834 15.0606C9.98232 15.0275 9.79012 14.9535 9.61866 14.8434C9.44721 14.7332 9.30012 14.5891 9.18645 14.4199L9.10645 14.3066C8.99726 14.1425 8.84828 14.0087 8.67341 13.9178C8.49854 13.8269 8.30349 13.7817 8.10645 13.7866C7.91843 13.7915 7.73419 13.8405 7.56859 13.9296C7.40299 14.0188 7.26067 14.1456 7.15311 14.2999L6.99978 14.5199C6.88608 14.6903 6.73869 14.8355 6.5667 14.9467C6.39472 15.058 6.20178 15.1328 5.99978 15.1666C5.91332 15.1751 5.82624 15.1751 5.73978 15.1666ZM2.93311 8.24659C3.30957 8.38083 3.64926 8.60157 3.92485 8.89104C4.20043 9.18052 4.40421 9.53065 4.51978 9.91325V9.99325C4.66374 10.391 4.711 10.8173 4.65768 11.2369C4.60436 11.6566 4.45197 12.0575 4.21311 12.4066C4.17095 12.4532 4.1476 12.5138 4.1476 12.5766C4.1476 12.6394 4.17095 12.7 4.21311 12.7466L5.64645 13.8333C5.66515 13.8479 5.68677 13.8585 5.70987 13.8641C5.73298 13.8697 5.75701 13.8704 5.78038 13.8659C5.80374 13.8615 5.82589 13.8522 5.84534 13.8385C5.86478 13.8248 5.88107 13.8071 5.89311 13.7866L6.04645 13.5666C6.27771 13.2324 6.58654 12.9593 6.94648 12.7707C7.30643 12.5821 7.70674 12.4835 8.11311 12.4835C8.51949 12.4835 8.9198 12.5821 9.27974 12.7707C9.63969 12.9593 9.94852 13.2324 10.1798 13.5666L10.2598 13.6866C10.2884 13.7273 10.3312 13.7558 10.3798 13.7666C10.4021 13.7699 10.4248 13.7686 10.4465 13.7629C10.4683 13.7572 10.4887 13.7471 10.5064 13.7333L11.8798 12.6933C11.9279 12.6551 11.9595 12.6 11.9682 12.5392C11.9768 12.4785 11.9619 12.4167 11.9264 12.3666L11.7531 12.1133C11.5273 11.7839 11.3783 11.4081 11.3171 11.0134C11.2559 10.6188 11.2842 10.2155 11.3998 9.83325C11.5169 9.4315 11.7289 9.06376 12.0177 8.76097C12.3066 8.45817 12.664 8.22918 13.0598 8.09325L13.1931 8.04659C13.2487 8.02433 13.2932 7.98099 13.3169 7.92603C13.3407 7.87108 13.3417 7.80896 13.3198 7.75325L12.7998 6.09325C12.7873 6.06421 12.769 6.038 12.7461 6.01623C12.7232 5.99445 12.6961 5.97757 12.6664 5.96659C12.6468 5.95663 12.6251 5.95144 12.6031 5.95144C12.5811 5.95144 12.5594 5.95663 12.5398 5.96659L12.3131 6.03992C11.9297 6.16647 11.5213 6.198 11.1229 6.13181C10.7246 6.06562 10.3483 5.90368 10.0264 5.65992L9.99978 5.59992C9.6909 5.366 9.44045 5.06366 9.2681 4.71664C9.09575 4.36963 9.00619 3.98738 9.00645 3.59992V3.39325C9.00765 3.329 8.98374 3.26681 8.93978 3.21992C8.90143 3.18526 8.85148 3.16623 8.79978 3.16659H7.10645C7.07929 3.16828 7.05273 3.17532 7.0283 3.18731C7.00387 3.19929 6.98205 3.21599 6.96408 3.23643C6.94612 3.25687 6.93237 3.28066 6.92362 3.30642C6.91488 3.33219 6.91131 3.35943 6.91311 3.38659V3.55325C6.91316 3.95128 6.82181 4.344 6.64613 4.70115C6.47044 5.05831 6.2151 5.37036 5.89978 5.61325L5.81311 5.67992C5.47293 5.93892 5.07426 6.11027 4.65224 6.17887C4.23022 6.24746 3.79781 6.21119 3.39311 6.07325C3.36283 6.06309 3.33006 6.06309 3.29978 6.07325C3.26216 6.09611 3.23382 6.13153 3.21978 6.17325L2.66645 7.91325C2.64716 7.97251 2.65168 8.03695 2.67905 8.09294C2.70642 8.14893 2.7545 8.19208 2.81311 8.21325L2.93311 8.24659Z"
        fill="#999999"
      />
      <path
        d="M7.99984 10.8333C7.53835 10.8333 7.08722 10.6964 6.70351 10.44C6.31979 10.1836 6.02072 9.81922 5.84412 9.39286C5.66751 8.9665 5.62131 8.49734 5.71134 8.04472C5.80137 7.5921 6.0236 7.17634 6.34992 6.85001C6.67625 6.52369 7.09201 6.30146 7.54463 6.21143C7.99725 6.1214 8.46641 6.16761 8.89277 6.34421C9.31913 6.52082 9.68354 6.81988 9.93993 7.2036C10.1963 7.58731 10.3332 8.03844 10.3332 8.49993C10.3332 9.11877 10.0873 9.71226 9.64975 10.1498C9.21217 10.5874 8.61868 10.8333 7.99984 10.8333ZM7.99984 7.49993C7.80206 7.49993 7.60872 7.55858 7.44427 7.66846C7.27982 7.77834 7.15165 7.93452 7.07596 8.11725C7.00027 8.29997 6.98047 8.50104 7.01905 8.69502C7.05764 8.889 7.15288 9.06718 7.29273 9.20704C7.43258 9.34689 7.61077 9.44213 7.80475 9.48072C7.99873 9.5193 8.1998 9.4995 8.38252 9.42381C8.56525 9.34812 8.72143 9.21995 8.83131 9.0555C8.94119 8.89105 8.99984 8.69771 8.99984 8.49993C8.99984 8.23471 8.89448 7.98036 8.70695 7.79282C8.51941 7.60529 8.26505 7.49993 7.99984 7.49993Z"
        fill="#999999"
      />
    </svg>
  );
};

export const IconOrdersAlertsNewOrder = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_17_563)">
        <circle cx="5" cy="5" r="4" fill="#03B0F7" />
        <circle cx="5" cy="5" r="3.5" stroke="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_17_563"
          x="0"
          y="0"
          width="10"
          height="10"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_17_563"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0117647 0 0 0 0 0.690196 0 0 0 0 0.968627 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_17_563"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_17_563"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const IconOrdersAlertsBack = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.48895C4.416 2.48895 1.5 5.40495 1.5 8.98895C1.5 12.573 4.416 15.489 8 15.489C11.584 15.489 14.5 12.573 14.5 8.98895C14.5 5.40495 11.584 2.48895 8 2.48895ZM8 3.48895C11.0435 3.48895 13.5 5.94545 13.5 8.98895C13.5 12.0325 11.0435 14.489 8 14.489C4.9565 14.489 2.5 12.0325 2.5 8.98895C2.5 5.94545 4.9565 3.48895 8 3.48895ZM7.64 5.78595L4.7975 8.62895L4.4375 8.98895L4.7975 9.34895L7.641 12.192L8.36 11.489L6.36 9.48895H11.5V8.48895H6.36L8.36 6.48895L7.64 5.78595Z"
        fill="#999999"
      />
    </svg>
  );
};

export const IconArrowRight = (props) => (
  <AiOutlineArrowRight
    color="#D1D1D1"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconVVStockDocument = () => {
  return (
    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.22396 29.75L4.39062 12.75H29.8906L27.0573 29.75H7.22396ZM9.59688 26.9167H24.6844L26.4906 15.5833H7.79063L9.59688 26.9167ZM14.3073 21.25H19.974C20.3753 21.25 20.712 21.114 20.984 20.842C21.256 20.57 21.3916 20.2338 21.3906 19.8333C21.3897 19.4329 21.2537 19.0967 20.9826 18.8247C20.7116 18.5527 20.3753 18.4167 19.974 18.4167H14.3073C13.9059 18.4167 13.5697 18.5527 13.2986 18.8247C13.0276 19.0967 12.8916 19.4329 12.8906 19.8333C12.8897 20.2338 13.0257 20.5705 13.2986 20.8434C13.5716 21.1164 13.9078 21.2519 14.3073 21.25ZM8.64062 11.3333C8.23924 11.3333 7.90301 11.1973 7.63196 10.9253C7.3609 10.6533 7.2249 10.3171 7.22396 9.91667C7.22301 9.51622 7.35901 9.18 7.63196 8.908C7.9049 8.636 8.24112 8.5 8.64062 8.5H25.6406C26.042 8.5 26.3787 8.636 26.6507 8.908C26.9227 9.18 27.0582 9.51622 27.0573 9.91667C27.0563 10.3171 26.9203 10.6538 26.6493 10.9267C26.3782 11.1997 26.042 11.3352 25.6406 11.3333H8.64062ZM11.474 7.08333C11.0726 7.08333 10.7363 6.94733 10.4653 6.67533C10.1942 6.40333 10.0582 6.06711 10.0573 5.66667C10.0563 5.26622 10.1923 4.93 10.4653 4.658C10.7382 4.386 11.0745 4.25 11.474 4.25H22.8073C23.2087 4.25 23.5454 4.386 23.8174 4.658C24.0894 4.93 24.2249 5.26622 24.224 5.66667C24.223 6.06711 24.087 6.40381 23.816 6.67675C23.5449 6.94969 23.2087 7.08522 22.8073 7.08333H11.474Z" fill="#CACACA" />
    </svg>
  );
}

export const IconVVStockProduct = () => {
  return (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30.6143 10.9268L27.6494 2.03223C27.2686 0.883789 26.1963 0.110352 24.9834 0.110352H16.6982V11.3604H30.6846C30.6611 11.2139 30.6611 11.0674 30.6143 10.9268ZM14.8232 0.110352H6.53809C5.3252 0.110352 4.25293 0.883789 3.87207 2.03223L0.907227 10.9268C0.860352 11.0674 0.860352 11.2139 0.836914 11.3604H14.8232V0.110352ZM0.760742 13.2354V27.2979C0.760742 28.8506 2.02051 30.1104 3.57324 30.1104H27.9482C29.501 30.1104 30.7607 28.8506 30.7607 27.2979V13.2354H0.760742Z" fill="#CACACA" />
    </svg>
  );
} 
export const IconMarketplace = (props) => {
  return (
    <svg 
      width="14" 
      height="14" 
      viewBox="0 0 14 14" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.375 6.58746H4.1875M4.1875 6.58746V4.89996M4.1875 6.58746H7M7 6.58746V4.89996M7 6.58746H9.8125M9.8125 6.58746V4.89996M9.8125 6.58746H12.625M5.3125 8.83746H6.4375M7.5625 8.83746H8.6875M7.5625 10.525H8.6875M5.3125 10.525H6.4375M1.9375 13.3375V6.58746H0.8125V4.33746L2.5 0.962463H11.5L13.1875 4.33746V6.58746H12.0625V13.3375H1.9375Z" stroke="black" strokeWidth="1.125" strokeLinejoin="round"/>
    </svg>
  );
};
export const IconTechnoramaDocuments = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 5.12976C3.39782 5.12976 3.77936 4.97173 4.06066 4.69042C4.34196 4.40912 4.5 4.02759 4.5 3.62976C4.5 3.23194 4.34196 2.85041 4.06066 2.5691C3.77936 2.2878 3.39782 2.12976 3 2.12976C2.60218 2.12976 2.22064 2.2878 1.93934 2.5691C1.65804 2.85041 1.5 3.23194 1.5 3.62976C1.5 4.02759 1.65804 4.40912 1.93934 4.69042C2.22064 4.97173 2.60218 5.12976 3 5.12976ZM3 5.12976V11.1298M9 8.12976C9.39782 8.12976 9.77936 8.2878 10.0607 8.5691C10.342 8.8504 10.5 9.23194 10.5 9.62976C10.5 10.0276 10.342 10.4091 10.0607 10.6904C9.77936 10.9717 9.39782 11.1298 9 11.1298C8.60218 11.1298 8.22064 10.9717 7.93934 10.6904C7.65804 10.4091 7.5 10.0276 7.5 9.62976C7.5 9.23194 7.65804 8.8504 7.93934 8.5691C8.22064 8.2878 8.60218 8.12976 9 8.12976ZM9 8.12976V4.37976C9 4.11454 8.89464 3.86019 8.70711 3.67265C8.51957 3.48512 8.26522 3.37976 8 3.37976H6.75"
      stroke="#828282"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 4.62976L6 3.37976L7.25 2.12976"
      stroke="#828282"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconStatistic = (props) => {
  return (
   <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 4V20H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6 15L10 11L14 13L18 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="15" r="1.5" fill="currentColor"/>
      <circle cx="10" cy="11" r="1.5" fill="currentColor"/>
      <circle cx="14" cy="13" r="1.5" fill="currentColor"/>
      <circle cx="18" cy="8" r="1.5" fill="currentColor"/>
    </svg>
  );
} 
